webpackJsonp([1],Array(51).concat([
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dexie__ = __webpack_require__(465);









var zip = window.zip;
var getDbNameFromUrl = function getDbNameFromUrl(url) {
  return url.split('?')[0].split('.')[0].split('_').pop();
};

function getUrl(url) {
  return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var http = new XMLHttpRequest();
    http.responseType = 'blob';
    http.onload = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          resolve(http.response);
        } else {
          reject(http.response);
        }
      }
    };
    http.open('GET', url, true);
    http.send();
  });
}

function getSqlite(content) {
  return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    zip.createReader(new zip.BlobReader(content), function (reader) {
      reader.getEntries(function (entries) {
        if (entries.length) {
          entries[0].getData(new zip.BlobWriter(), function (blob) {
            var blobReader = new FileReader();
            blobReader.addEventListener('error', function (e) {
              return reject(e);
            });
            blobReader.addEventListener('load', function () {
              reader.close(function () {
                resolve(blobReader.result);
              });
            });
            blobReader.readAsArrayBuffer(blob);
          });
        }
      });
    });
  });
}

var TABLES = ['DestinyClassDefinition', 'DestinyDamageTypeDefinition', 'DestinyGenderDefinition', 'DestinyInventoryBucketDefinition', 'DestinyInventoryItemDefinition', 'DestinyItemCategoryDefinition', 'DestinyItemTierTypeDefinition', 'DestinyRaceDefinition', 'DestinyStatDefinition'
// 'DestinyActivityDefinition',
// 'DestinyActivityGraphDefinition',
// 'DestinyActivityModeDefinition',
// 'DestinyActivityModifierDefinition',
// 'DestinyActivityTypeDefinition',
// 'DestinyBondDefinition',
// 'DestinyDestinationDefinition',
// 'DestinyEnemyRaceDefinition',
// 'DestinyFactionDefinition',
// 'DestinyHistoricalStatsDefinition',
// 'DestinyLocationDefinition',
// 'DestinyLoreDefinition',
// 'DestinyMedalTierDefinition',
// 'DestinyMilestoneDefinition',
// 'DestinyObjectiveDefinition',
// 'DestinyPlaceDefinition',
// 'DestinyProgressionDefinition',
// 'DestinyProgressionLevelRequirementDefinition',
// 'DestinyRewardSourceDefinition',
// 'DestinySackRewardItemListDefinition',
// 'DestinySandboxPerkDefinition',
// 'DestinySocketCategoryDefinition',
// 'DestinySocketTypeDefinition'
// 'DestinyStatGroupDefinition'
// 'DestinyTalentGridDefinition',
// 'DestinyUnlockDefinition',
// 'DestinyVendorCategoryDefinition',
// 'DestinyVendorDefinition'
];

function getSqliteData(database) {
  return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var worker = new Worker('/static/sqlite/worker.sql.js');
    worker.onmessage = function () {
      var results = {};
      worker.onmessage = function (_ref) {
        var data = _ref.data;

        results[data.id] = data.results[0].values.reduce(function (accumulated, current, i) {
          var v = JSON.parse(current[1]);
          accumulated[v.hash] = v;
          return accumulated;
        }, {});
        if (TABLES.length - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(results).length === 0) {
          resolve(results);
        }
      };
      TABLES.forEach(function (table) {
        worker.postMessage({
          id: table,
          action: 'exec',
          sql: 'SELECT id,json FROM ' + table
        });
      });
    };
    worker.onerror = function (e) {
      return console.error('Worker errror', e);
    };
    worker.onerrorload = function (e) {
      return console.error('Worker errror', e);
    };
    worker.postMessage({
      id: 1,
      action: 'open',
      buffer: database
    });
  });
}

function fetchAndFillDatabase(url, db) {
  return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    getUrl('https://www.bungie.net' + url).then(getSqlite).then(getSqliteData).then(function (definitions) {
      var tables = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(definitions);

      console.log('got version 1');
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(tables.map(function (table) {
        console.log('adding ' + table);
        return db[table].bulkAdd(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(definitions[table]).map(function (_ref2) {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
              id = _ref3[0],
              row = _ref3[1];

          return [['id', parseInt(id)]].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(row))).reduce(function (acc, _ref4) {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                k = _ref5[0],
                v = _ref5[1];

            acc[k] = v;
            return acc;
          }, {});
        })).then(function () {
          console.log('Table ' + table + ' created');
        });
      })).then(function () {
        resolve(db);
      });
    });
  });
}

function cleanupDatabases(dbName, changeCallback) {
  return __WEBPACK_IMPORTED_MODULE_7_dexie__["a" /* default */].getDatabaseNames().then(function (names) {
    var toDelete = names.filter(function (name) {
      return name.startsWith('destiny-manifest');
    }).filter(function (name) {
      return name !== dbName;
    });
    if (toDelete) {
      changeCallback('Cleaning up old manifest database');
      toDelete.forEach(function (name) {
        __WEBPACK_IMPORTED_MODULE_7_dexie__["a" /* default */].delete(name);
      });
    }
  });
}

function processIfEmpty(url, changeCallback, counts) {
  var _this = this;

  var hasEmpty = counts.find(function (count) {
    return count === 0;
  }) === 0;
  return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (hasEmpty) {
      changeCallback('Downloading new manifest file');
      fetchAndFillDatabase(url, _this.db).then(resolve);
    } else {
      changeCallback('Using old manifest');
      resolve(_this.db);
    }
  });
}

function fillDefinitions(db, hangeCallback) {
  var _this2 = this;

  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(TABLES.map(function (table) {
    return db[table].each(function (item) {
      _this2.definitions[table][item.id] = item;
    });
  }));
}

var Database = function () {
  function Database() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Database);

    this.definitions = TABLES.reduce(function (acc, table) {
      acc[table] = {};
      return acc;
    }, {});
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Database, [{
    key: 'createDb',
    value: function createDb(dbName) {
      this.db = new __WEBPACK_IMPORTED_MODULE_7_dexie__["a" /* default */](dbName);
      this.db.version(1).stores(TABLES.reduce(function (acc, table) {
        acc[table] = 'id';
        return acc;
      }, {}));
    }
  }, {
    key: 'load',
    value: function load(version, url, changeCallback) {
      var _this3 = this;

      changeCallback('Loading manifest');
      return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.createDb('destiny-manifest-' + getDbNameFromUrl(url));
        _this3.db.open().then(function () {
          __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(TABLES.map(function (table) {
            return database.db[table].count();
          })).then(processIfEmpty.bind(_this3, url, changeCallback)).then(fillDefinitions.bind(_this3, _this3.db, changeCallback)).then(cleanupDatabases.bind(_this3, _this3.db.name, changeCallback)).then(function () {
            changeCallback('Manifest loaded');
            resolve(_this3);
          });
        });
      });
    }
  }, {
    key: 'getClass',
    value: function getClass(classHash) {
      return this.definitions.DestinyClassDefinition[classHash];
    }
  }, {
    key: 'getRace',
    value: function getRace(raceHash) {
      return this.definitions.DestinyRaceDefinition[raceHash];
    }
  }, {
    key: 'getItemDefinition',
    value: function getItemDefinition(itemHash) {
      return this.definitions.DestinyInventoryItemDefinition[itemHash];
    }
  }, {
    key: 'getCategory',
    value: function getCategory(categoryId) {
      return this.definitions.DestinyItemCategoryDefinition[categoryId];
    }
  }, {
    key: 'getDamageType',
    value: function getDamageType(damageTypeHash) {
      return this.definitions.DestinyDamageTypeDefinition[damageTypeHash];
    }
  }, {
    key: 'getInventoryBucket',
    value: function getInventoryBucket(inventoryBucketHash) {
      return this.definitions.DestinyInventoryBucketDefinition[inventoryBucketHash];
    }
  }, {
    key: 'getTierType',
    value: function getTierType(tierTypeHash) {
      return this.definitions.DestinyItemTierTypeDefinition[tierTypeHash];
    }
  }, {
    key: 'getStat',
    value: function getStat(statHash) {
      return this.definitions.DestinyStatDefinition[statHash];
    }
  }]);

  return Database;
}();

var database = new Database();
if (false) {
  window.database = database;
}

/* harmony default export */ __webpack_exports__["a"] = (database);

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_string__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_database__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sourceData__ = __webpack_require__(181);














var FilterDefinition = function FilterDefinition(name, label, itemsGetter, mutation, matchFunction, type) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, FilterDefinition);

  this.name = name;
  this.label = label;
  this.itemsGetter = itemsGetter;
  this.mutation = mutation;
  this.matchFunction = matchFunction;
  this.type = type || 'checkbox';
};

var getCategories = function getCategories() {
  return __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.getters['destiny/profile/allItemsCategories'].map(function (category) {
    return {
      'hash': category.hash,
      'name': category.displayProperties.name
    };
  });
};

var getSubtypes = function getSubtypes() {
  return [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.state.destiny.profile.items.filter(function (i) {
    return i.damageType.id;
  }).map(function (i) {
    return i.definition.itemTypeDisplayName;
  })))).sort().map(function (i) {
    return {
      hash: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* hashCode */])(i),
      name: i
    };
  });
};

var getRarity = function getRarity() {
  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_database__["a" /* default */].definitions.DestinyItemTierTypeDefinition).sort(function (a, b) {
    return a.index < b.index ? 1 : -1;
  }).map(function (tier) {
    return {
      hash: tier.hash,
      name: tier.displayProperties.name
    };
  }).filter(function (tier) {
    return __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.state.destiny.profile.items.filter(function (i) {
      return i.tierType.hash === tier.hash;
    }).length;
  });
};

var getModsRarity = function getModsRarity() {
  var allMods = __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.state.destiny.profile.items.filter(function (i) {
    return i.definition.itemType === 19;
  });
  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_database__["a" /* default */].definitions.DestinyItemTierTypeDefinition).sort(function (a, b) {
    return a.index < b.index ? 1 : -1;
  }).map(function (tier) {
    return {
      hash: tier.hash,
      name: tier.displayProperties.name
    };
  }).filter(function (tier) {
    return allMods.filter(function (i) {
      return i.tierType.hash === tier.hash;
    }).length;
  });
};
var getSets = function getSets() {
  return __WEBPACK_IMPORTED_MODULE_12__sourceData__["a" /* default */].map(function (_ref) {
    var name = _ref.name;

    return { name: name, hash: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* hashCode */])(name) };
  });
};

var getDamageType = function getDamageType() {
  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_database__["a" /* default */].definitions.DestinyDamageTypeDefinition).sort(function (a, b) {
    return a.index < b.index ? -1 : 1;
  }).map(function (damageType) {
    return {
      hash: damageType.hash,
      name: damageType.displayProperties.name,
      icon: damageType.displayProperties.icon
    };
  });
};

var getVarious = function getVarious() {
  return __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.state.destiny.filters.variousLabels.map(function (name, i) {
    return { hash: i, name: name };
  });
};

function modsRarityMatch(item, value) {
  var socketRarities = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a(item.displayableSockets.map(function (socket) {
    return socket.inventory.tierTypeHash;
  }));
  return value.find(function (rarity) {
    return socketRarities.has(rarity);
  }) !== undefined;
}

function getSourceMatch(item, value) {
  return item.sources.map(function (source) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* hashCode */])(source);
  }).find(function (code) {
    return value.find(function (needle) {
      return needle === code;
    });
  }) !== undefined;
}

function variousMatch(item, value) {
  return value.map(function (index) {
    return __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.state.destiny.filters.variousLabels[index];
  }).every(function (label) {
    return label === 'Duplicated' && item.isDuplicate || label === 'Different' && !item.isDuplicate || label === 'Favorited' && item.favorited || label === 'Unfavorited' && !item.favorited || label === 'Equipped' && item.equipped || label === 'Unequipped' && !item.equipped || label === 'Transferable' && item.isTransferable || label === 'Untransferable' && !item.isTransferable || label === 'Best duplicates' && item.isBestDuplicate || label === 'Worst duplicates' && item.isBestDuplicate === false;
  });
}

function searchMatch(item, value) {
  var tokens = value.toLowerCase().split(' ').map(function (w) {
    return w.trim();
  }).filter(function (w) {
    return w;
  });
  return tokens.every(function (token) {
    return item.checkToken(token);
  });
}

var defaultFilterDefinitions = [new FilterDefinition('search', '', null, '', searchMatch), new FilterDefinition('categories', 'Categories', getCategories, 'destiny/filters/updateCategories', function (item, value) {
  return value.indexOf(item.bucket.hash) !== -1;
}), new FilterDefinition('subtypes', 'Weapon subtype', getSubtypes, 'destiny/filters/updateSubtypes', function (item, value) {
  return value.indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* hashCode */])(item.definition.itemTypeDisplayName)) !== -1;
}, 'radio'), new FilterDefinition('damageType', 'Damage Type', getDamageType, 'destiny/filters/updateDamageType', function (item, value) {
  return value.indexOf(item.damageType.hash) !== -1;
}), new FilterDefinition('rarity', 'Rarity', getRarity, 'destiny/filters/updateRarity', function (item, value) {
  return value.indexOf(item.tierType.hash) !== -1;
}), new FilterDefinition('modsRarity', 'Mods Rarity', getModsRarity, 'destiny/filters/updateModsRarity', modsRarityMatch), new FilterDefinition('sets', 'Source', getSets, 'destiny/filters/updateSets', getSourceMatch), new FilterDefinition('various', 'Various', getVarious, 'destiny/filters/updateVarious', variousMatch)];

var Filter = function () {
  function Filter(value, filterDefinition) {
    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, Filter);

    this.value = value;
    this.filterDefinition = filterDefinition;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Filter, [{
    key: 'match',
    value: function match(item) {
      return this.filterDefinition.matchFunction ? this.filterDefinition.matchFunction(item, this.value) : false;
    }
  }, {
    key: 'name',
    get: function get() {
      return this.filterDefinition.name;
    }
  }, {
    key: 'label',
    get: function get() {
      return this.filterDefinition.label;
    }
  }, {
    key: 'items',
    get: function get() {
      return this.filterDefinition.itemsGetter ? this.filterDefinition.itemsGetter() : [];
    }
  }, {
    key: 'model',
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      var _this = this;

      setTimeout(function () {
        var payload = {};
        payload[_this.name] = value;
        __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.commit(_this.filterDefinition.mutation, payload);
      });
    }
  }, {
    key: 'display',
    get: function get() {
      var _this2 = this;

      return this.label ? this.items.filter(function (_ref2) {
        var hash = _ref2.hash;
        return _this2.value.indexOf(hash) !== -1;
      }).map(function (_ref3) {
        var name = _ref3.name;
        return name;
      }) : [this.value];
    }
  }]);

  return Filter;
}();

var FiltersCollection = function () {
  function FiltersCollection(values, filterDefinitions) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_classCallCheck___default()(this, FiltersCollection);

    this.filters = (filterDefinitions || defaultFilterDefinitions).reduce(function (acc, filterDefinition) {
      acc[filterDefinition.name] = new Filter(values[filterDefinition.name], filterDefinition);
      return acc;
    }, {});
    this.filtersValues = {};
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(this.filters).forEach(function (filter) {
      _this3.filtersValues[filter.name] = values[filter.name];
    });
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(FiltersCollection, [{
    key: 'getValue',
    value: function getValue(filter) {
      return this.filtersValues[filter];
    }
  }, {
    key: 'setValue',
    value: function setValue(filter, value) {
      var _this4 = this;

      setTimeout(function () {
        var payload = {};
        payload[filter] = value;
        __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].store.commit(_this4.filterArguments[filter].mutation, payload);
      });
    }
  }, {
    key: 'filter',
    value: function filter(items) {
      var _this5 = this;

      var toApply = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.cleanFilters).map(function (key) {
        return _this5.filters[key];
      });
      return items.filter(function (item) {
        return toApply.find(function (filter) {
          return !filter.match(item);
        }) === undefined;
      });
    }
  }, {
    key: 'cleanFilters',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.filtersValues).filter(function (_ref4) {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
            k = _ref5[0],
            v = _ref5[1];

        return v && v.length;
      }).reduce(function (acc, _ref6) {
        var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
            k = _ref7[0],
            v = _ref7[1];

        acc[k] = v;
        return acc;
      }, {});
    }
  }, {
    key: 'exportable',
    get: function get() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.cleanFilters)))).reduce(function (acc, item, i) {
        acc[i >> 5] = (acc[i >> 5] || '') + item;
        return acc;
      }, []).join('\n');
    }
  }, {
    key: 'displayValues',
    get: function get() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.cleanFilters).map(function (key) {
        return [key, _this6.filters[key].display];
      }).reduce(function (acc, _ref8) {
        var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref8, 2),
            key = _ref9[0],
            values = _ref9[1];

        acc[_this6.filters[key].label || key] = values;
        return acc;
      }, {});
    }
  }], [{
    key: 'fromExportable',
    value: function fromExportable(exportable, filterDefinitions) {
      var values = void 0;
      try {
        values = JSON.parse(atob(exportable.replace(/\n/g, '')));
      } catch (e) {
        values = { search: exportable };
      }

      return new FiltersCollection(values, filterDefinitions);
    }
  }]);

  return FiltersCollection;
}();

/* harmony default export */ __webpack_exports__["a"] = (FiltersCollection);

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__queue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__destiny__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__firebase_auth__ = __webpack_require__(363);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* default */]);











function loadFavorities() {
  try {
    return JSON.parse(localStorage.getItem('favorites') || '[]');
  } catch (e) {
    return [];
  }
}

var DEFAULT_TAGS_DEFINITIONS = {
  'PvP': { 'color': '#b71c1c' },
  'Raid set': { 'color': '#1A237E' },
  'Nightfall set': { 'color': '#263238' }
};

function loadTagsDefinitions() {
  try {
    return JSON.parse(localStorage.getItem('tagsDefinitions') || 'false') || DEFAULT_TAGS_DEFINITIONS;
  } catch (e) {
    return DEFAULT_TAGS_DEFINITIONS;
  }
}

function loadTags() {
  try {
    return JSON.parse(localStorage.getItem('tags') || 'false') || {};
  } catch (e) {
    return {};
  }
}

var state = {
  destinyAccounts: null,
  favorites: loadFavorities(),
  tagsDefinitions: loadTagsDefinitions(),
  tags: loadTags()
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__,
  modules: {
    queue: __WEBPACK_IMPORTED_MODULE_5__queue__["a" /* default */],
    errors: __WEBPACK_IMPORTED_MODULE_6__errors__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */],
    destiny: __WEBPACK_IMPORTED_MODULE_8__destiny__["a" /* default */],
    firebaseAuth: __WEBPACK_IMPORTED_MODULE_10__firebase_auth__["a" /* default */]
  }
});

/* firebase */
/* TODO: cleanup favs */

store.watch(function () {
  return store.state.firebaseAuth.user;
}, function (newUser) {
  if (newUser) {
    if (store.state.firebaseAuth.user) {
      var favoritiesRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('favorities').doc(store.state.firebaseAuth.user.uid);
      favoritiesRef.onSnapshot(function (doc) {
        if (doc.exists) {
          store.commit('setFavorities', doc.data());
        }
      });
      var searchesRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('searches').doc(store.state.firebaseAuth.user.uid);
      searchesRef.onSnapshot(function (doc) {
        if (doc.exists) {
          store.commit('destiny/filters/updateSearches', doc.data());
        }
      });
      var tagsDefinitionsRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('tagsDefinitions').doc(store.state.firebaseAuth.user.uid);
      tagsDefinitionsRef.onSnapshot(function (doc) {
        if (doc.exists) {
          store.commit('updateTagsDefinitions', doc.data());
        }
      });
      var tagsRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('tags').doc(store.state.firebaseAuth.user.uid);
      tagsRef.onSnapshot(function (doc) {
        if (doc.exists) {
          store.commit('updateTags', doc.data());
        }
      });
    }
  }
});

store.watch(function () {
  return store.state.favorites;
}, function (favorities) {
  if (store.state.firebaseAuth.user.uid) {
    var favoritiesRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('favorities').doc(store.state.firebaseAuth.user.uid);
    favoritiesRef.set({ favorities: favorities });
  }
});

store.watch(function () {
  return store.state.destiny.filters.searches;
}, function (searches) {
  if (store.state.firebaseAuth.user.uid) {
    var searchesRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('searches').doc(store.state.firebaseAuth.user.uid);
    searchesRef.set({ searches: searches });
  }
});

store.watch(function () {
  return store.state.tagsDefinitions;
}, function (tagsDefinitions) {
  if (store.state.firebaseAuth.user.uid) {
    var tagsDefinitionsRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('tagsDefinitions').doc(store.state.firebaseAuth.user.uid);
    tagsDefinitionsRef.set({ tagsDefinitions: tagsDefinitions });
  }
}, { deep: true });

store.watch(function () {
  return store.state.tags;
}, function (tags) {
  if (store.state.firebaseAuth.user.uid) {
    var tagsRef = __WEBPACK_IMPORTED_MODULE_9_firebase___default.a.firestore().collection('tags').doc(store.state.firebaseAuth.user.uid);
    tagsRef.set({ tags: tags });
  }
}, { deep: true });

store.watch(function () {
  return store.state.destiny.filters.search;
}, function (newSearch) {
  store.dispatch('destiny/filters/computeTokens');
});

if (false) {
  window.store = store;
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export itemCompare */
/* harmony export (immutable) */ __webpack_exports__["b"] = byTierType;
/* unused harmony export byPowerLevel */
/* unused harmony export byName */
/* unused harmony export byNameAndPowerLevel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderings; });
function typeToImportance(item) {
  switch (item.definition.itemType) {
    case 3:
      // weapon
      return 1;
    case 2:
      // armor
      return 2;
    case 8:
      return 3;
    case 9:
      return 4;
    default:
      return 5;
  }
}

function compare(a, b) {
  if (a !== b) {
    return a < b ? -1 : 1;
  }
  return 0;
}

function itemCompare(a, b) {
  /* type */
  return compare(a.favorited ? 0 : 1, b.favorited ? 0 : 1) || compare(typeToImportance(a), typeToImportance(b)) || // type
  compare(a.bucket.bucketOrder, b.bucket.bucketOrder) || // sub type
  byTierType(a, b) || // tier
  byName(a, b) || byPowerLevel(a, b);
}

function byTierType(a, b) {
  return compare(-a.tierType.index, -b.tierType.index);
}

function byPowerLevel(a, b) {
  return 0;
}

function byName(a, b) {
  return compare(a.name, b.name);
}

function byNameAndPowerLevel(a, b) {
  return byName(a, b) || byPowerLevel(a, b);
}

var orderings = {
  'Default': itemCompare,
  'By Power Level': byPowerLevel,
  'By Name': byNameAndPowerLevel
};

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OAUTH_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_KEY; });
var OAUTH_CLIENT_ID = 20813;
var API_KEY = "0edae4339ead49b889ad3f323e4654cf";

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Home__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Auth__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Manager__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_Manager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Loading__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_FilterPage__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_FilterPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_FilterPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_ItemDetail__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_ItemDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_ItemDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Settings__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Tools__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_Tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Help__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FirebaseAuth__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FirebaseAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_FirebaseAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(95);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var forLogged = function forLogged(whereTo) {
  return function (to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['auth/isLogged']) {
      return next(whereTo);
    }
    next();
  };
};

var forNotLogged = function forNotLogged(whereTo) {
  return function (to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters['auth/isLogged']) {
      return next(whereTo);
    }
    next();
  };
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Home___default.a,
    beforeEnter: forNotLogged({ name: 'loader' })
  }, {
    path: '/help/',
    name: 'help',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Help___default.a
  }, {
    path: '/auth/',
    name: 'auth',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Auth___default.a
  }, {
    path: '/firebase-auth/',
    name: 'firebase-auth',
    component: __WEBPACK_IMPORTED_MODULE_11__components_FirebaseAuth___default.a
  }, {
    path: '/manager/',
    name: 'loader',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Loading___default.a,
    beforeEnter: forLogged('/')
  }, {
    path: '/manager/:character/',
    name: 'manager',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Manager___default.a,
    beforeEnter: forLogged('/')
  }, {
    path: '/item/:instanceId/',
    name: 'item',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_ItemDetail___default.a,
    beforeEnter: forLogged('/'),
    props: true
  }, {
    path: '/filter/',
    name: 'filter',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_FilterPage___default.a,
    beforeEnter: forLogged('/')
  }, {
    path: '/settings',
    name: 'settings',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_Settings___default.a
  }, {
    path: '/tools',
    name: 'tools',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_Tools___default.a,
    beforeEnter: forLogged('/')
  }]
}));

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Trials of the Nine',
  items: [174804902, 1187594590, 1825472717, 1879212552, 1909527966, 2094938673, 2850415209, 3854037061, 400025383, 2641591726, 548290754, 854160040, 238320915, 400025382, 2641591727, 548290755, 854160041, 238320914, 2391227801, 1863012880, 934145080, 2221648234, 3624606677, 2391227800, 1863012881, 934145081, 2221648235, 3624606676, 2964441920, 530515217, 891933383, 4232174819, 1607431126, 2964441921, 530515216, 891933382, 4232174818, 1607431127]
}, {
  name: 'Leviathan',
  items: [2505533224, 3325744914, 3906942101, 1128225405, 3954531357, 3380742308, 3691881271, 1018072983, 2013109092, 1960303677, 407863747, 30962015, 3984534842, 2013109093, 1960303676, 407863746, 30962014, 3984534843, 1413589586, 1879942843, 1876645653, 288406317, 574137192, 1413589587, 1879942842, 1876645652, 288406316, 574137193, 2700598111, 2676042150, 3592548938, 2193494688, 3763332443, 2700598110, 2676042151, 3592548939, 2193494689, 3763332442]
}, {
  name: 'Iron Banner',
  items: [2014642399, 4425887, 3890960908, 1189790632, 3424403076, 2961807684, 2909905776, 807192446, 1496224967, 3737894478, 831464034, 1526005320, 479917491, 1804445917, 691332172, 3865618708, 1337167606, 738938985, 2811201658, 287471683, 124696333, 2674485749, 2999505920]
}, {
  name: 'Dead Orbit',
  items: [1587439031, 582335600, 48361213, 1277015089, 48361212, 472847207, 1459443448, 2625782212, 2625782213, 3252697558, 132368575, 66235782, 3146241834, 3920232320, 3783059515, 1978760489, 4065136800, 387100392, 2760076378, 2089197765, 3299588760, 3763392361, 2873960175, 4055334203, 4121118846]
}, {
  name: 'New Monarchy',
  items: [705774642, 3435238842, 3889907763, 1988218406, 3435238843, 2693941407, 227548887, 3239754990, 2276266837, 755928510, 25798127, 3323316553, 600401425, 342618372, 3059968532, 1890693805, 2154427219, 2603069551, 106359434, 316745113, 4083497488, 2436244536, 147165546, 831738837]
}, {
  name: 'Future War Cult',
  items: [408440598, 3854359821, 1342668638, 3272713429, 1006783454, 1339362514, 2581162758, 3329842376, 4145119417, 1763431309, 2415993980, 1355893732, 1418921862, 2524181305, 1187431263, 1162875302, 3671665226, 680327840, 3842448731, 2401598772, 807866445, 3656154099, 1478665487, 1566612778]
}, {
  name: 'European Dead Zone Gear',
  items: [3762467078, 1885753222, 2145476620, 1911843789, 1513927138, 287042893, 731147177, 2502422772, 1983332560, 3312073054, 3973359167, 3907226374, 2729740202, 3466255616, 3366557883, 3080875433, 872284448, 10307688, 3862191322, 1712405061, 3764013786, 1664741411, 2724176749, 4051755349, 1304122208]
}, {
  name: 'Echo Mesa, Io Gear',
  items: [3762467079, 1911843788, 731147179, 287042894, 3312073055, 2502422775, 417474226, 1983332562, 2715114534, 1729074423, 1085797441, 3537609113, 1868302492, 1370341044, 4071576013, 2523633779, 447407759, 434092458, 1554079989, 229923140, 3388454204, 2160569198, 845354673]
}, {
  name: 'New Pacific Arcology Gear',
  items: [3762467077, 1885753223, 2145476623, 1911843790, 2700862856, 3312073052, 1513927136, 287042892, 2502422774, 417474224, 1607012852, 479417869, 2380978355, 1150216911, 291437034, 2930137294, 3955340735, 1847610489, 2876590849, 3586337076, 2575848725, 1251692004, 2400621276, 2757777294, 3686454865]
}, {
  name: 'Arcadian Valley, Nessus Gear',
  items: [3762467076, 1885753220, 2145476622, 1911843791, 1513927139, 2700862858, 3312073053, 2502422773, 417474225, 1983332561, 3026265798, 2423003287, 2462524641, 3807183801, 3669590332, 1010733668, 957928253, 177493699, 3323553887, 3754164794, 2811068561, 1427620200, 2359639520, 2528959426, 1669675549]
}, {
  name: 'Vanguard Tactician Gear',
  items: [1644162710, 1960218487, 1200414607, 3582424018, 3967155859, 1351035691, 339163900, 137879537, 2290863050, 3445437901, 2168486467, 3198744410, 1099472035, 406401261, 3486485973, 3281314016, 3873435116, 3027732901, 1667528443, 3375062567, 24244626, 1540376513, 2378296024, 34846448, 413460498, 3215392301]
}, {
  name: 'Vanguard Research Gear',
  items: [4248632159, 4224076198, 385045066, 3741528736, 555828571, 4081859017, 1490387264, 2682045448, 185326970, 89175653, 2615512594, 3081969019, 868792277, 1532009197, 4285708584]
}, {
  name: 'Crucible Engram',
  items: [3336215727, 4193877020, 1048266744, 1325579289, 962412079, 4174481098, 2660862359, 1773600468, 2621637518, 3223280471, 2296691422, 2718495762, 3140634552, 3313736739, 2191401041, 849529384, 2815422368, 1484937602, 1742680797, 1764274932, 636679949, 1333087155, 1307478991, 3538513130]
}, {
  name: 'Gunsmith Arsenal',
  items: [3778520451, 3778520450, 273396910, 925326393, 925326392, 925326394, 3860697510, 3860697508, 1533499360, 1533499361, 1533499362, 566976652, 566976653, 566976654, 339343291, 339343290, 3748713779, 3748713778, 3666954562, 3666954561, 3666954563, 2703340117, 2398848320, 896923850, 3778520449]
}, {
  name: 'Bright Engram, Eververse',
  items: [1869779952, 1625986881, 369186071, 2696374963, 2497505510, 1638376198, 652336087, 415074081, 2460870905, 1197579132, 2956899553, 3794819064, 199852048, 1830086706, 3421974605]
}, {
  name: 'Engrams',
  items: [3125909492, 1998314509, 316000947, 2669113551, 2521426922, 2550994842, 493299171, 1024867629, 2414278933, 3433746208, 269552461, 922218300, 1415533220, 308026950, 2159363321, 155832748, 3646674533, 3066593211, 3569443559, 1847870034, 160388292, 107582877, 2696303651, 2048751167, 1978110490, 2525344810, 2530905971, 1364856221, 2265859909, 2826844112, 3725654227, 1260134370, 2932121030, 3304280092, 3250112431, 690335398, 3999262583, 3291075521, 1512829977, 4073580572, 2791527489, 3629447000, 3884999792, 1664611474, 2770578349, 2542514983, 489114030, 683173058, 2996649640, 373203219, 993844472, 1457647945, 410671183, 1749589787, 2082184158, 2811180959, 3169402598, 4092393610, 2728535008, 434243995]
}, {
  name: 'Eververse',
  items: [2833999140, 2833999141, 2833999142, 2833999143, 2833999136, 2833999137, 2833999138, 2833999139, 2833999148, 2833999149, 261110023, 261110022, 261110024, 261110025, 261110026, 261110027, 261110028, 261110030, 261110031, 261110029, 277887714, 277887715, 277887712, 277887713, 277887718, 93029343, 93029342, 292778444, 454583975, 2543806755, 412299646, 664042851, 938804347, 3129418034, 3872116425, 1120064792, 718136887, 2741695224, 1061186327, 4223882778, 2649911453, 1177179936, 1954221115, 2870168892, 4187524534, 3199368173, 3811760832, 1294717622, 2526538979, 3526028978, 333041308, 807458183, 807458182, 807458181, 3889183914, 3889183915, 3889183912, 3889183913, 3889183918, 3889183919, 3889183916, 3889183917, 3889183906, 3889183907, 2546958593, 2546958592, 2546958594, 2546958597, 2546958596, 2546958599, 2546958598, 904825093, 904825092, 904825094, 904825089, 904825088, 2503134037, 838210459, 4209989368, 96858972, 3213307847, 1104161649, 2503134032, 2503134038, 2503134039, 2503134036, 2503134042, 838210457, 838210456, 4209989372, 4209989373, 4209989370, 4209989371, 4209989369, 4209989366, 96858973, 4209989367, 3213307843, 3213307842, 3213307845, 3213307844, 3213307846, 3213307849, 3213307848]
}]);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emptyFilters */
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanFilters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);


var emptyFilters = {
  search: '',
  categories: [],
  subtypes: [],
  rarity: [],
  modsRarity: [],
  damageType: [],
  various: [],
  tokens: [],
  sets: []
};

function cleanFilters(state) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(emptyFilters).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    state[k] = v;
  });
}

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(565),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c2b77ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e9a460a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(95);

/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
  install: function install(Vue, options) {
    Vue.store = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */];
    Vue.prototype.$store = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */];
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: "AIzaSyBnrd2mJiSrfnbVgcg44Q2-t16ke-7VbO8",
  authDomain: 'itemmanager.uk',
  databaseURL: 'https://item-manager-fdf57.firebaseio.com',
  projectId: 'item-manager-fdf57',
  storageBucket: 'item-manager-fdf57.appspot.com',
  messagingSenderId: '1080753689106'
});

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(551),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var _class = function _class(_ref) {
  var label = _ref.label,
      url = _ref.url,
      method = _ref.method,
      payload = _ref.payload;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

  this.label = label;
  this.url = url;
  this.method = method;
  this.payload = payload;
};

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_database__ = __webpack_require__(51);




var Character = function () {
  function Character(data) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Character);

    this.data = data;
    this.key = data.characterId;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Character, [{
    key: 'characterId',
    get: function get() {
      return this.data.characterId;
    }
  }, {
    key: 'emblemBackgroundPath',
    get: function get() {
      return 'https://www.bungie.net' + this.data.emblemBackgroundPath;
    }
  }, {
    key: 'emblemPath',
    get: function get() {
      return 'https://www.bungie.net' + this.data.emblemPath;
    }
  }, {
    key: 'class_',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__utils_database__["a" /* default */].getClass(this.data.classHash);
    }
  }, {
    key: 'race',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__utils_database__["a" /* default */].getRace(this.data.raceHash);
    }
  }, {
    key: 'raceName',
    get: function get() {
      return this.race.displayProperties.name;
    }
  }, {
    key: 'className',
    get: function get() {
      return this.class_.displayProperties.name;
    }
  }, {
    key: 'gender',
    get: function get() {
      return {};
      // return definitions.getGender(this.data.characterBase.genderHash)
    }
  }, {
    key: 'light',
    get: function get() {
      return this.data.light;
    }
  }, {
    key: 'level',
    get: function get() {
      return this.data.levelProgression.level;
    }
  }, {
    key: 'isVault',
    get: function get() {
      return false;
    }
  }]);

  return Character;
}();

/* harmony default export */ __webpack_exports__["a"] = (Character);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_database__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Socket__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Source__ = __webpack_require__(334);












var LOCK_FLAG = 1;

function stringToSlug(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  var to = 'aaaaeeeeiiiioooouuuunc------';
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
  .replace(/\s+/g, '-') // collapse whitespace and replace by -
  .replace(/-+/g, '-'); // collapse dashes

  return str;
}

var Item = function () {
  function Item(data, characterHash) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Item);

    this.data = data;
    this._characterHash = characterHash;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Item, [{
    key: 'canTransferTo',
    value: function canTransferTo(selectedCharacter) {
      if (this.characterHash === 'INVENTORY') {
        return selectedCharacter === 'VAULT';
      }

      return this.characterHash !== selectedCharacter;
    }
  }, {
    key: 'checkToken',


    /* check if search token is found in item */
    value: function checkToken(token) {
      if ((this.name.toLowerCase() + ' ' + this.tokens.join(' ')).indexOf(token) !== -1) {
        return true;
      }
      // eslint-disable-next-line no-useless-escape
      var re = /^(\d+)([\-\+](\d*))?$/.exec(token);
      var count = this.primaryStat || this.data.quantity;
      if (re) {
        var from = parseInt(re[1]);
        if (re[2] === undefined) {
          if (from === count) {
            return true;
          }
        } else if (count >= from) {
          var to = parseInt(re[3]);
          if (isNaN(to)) {
            return true;
          } else {
            return count <= to;
          }
        }
      }
      return false;
    }
  }, {
    key: 'transfer',


    /* actions */
    value: function transfer(character) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this.canTransferTo(character.characterId)) {
          return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.dispatch('destiny/profile/transferItem', { item: _this, character: character }).then(function () {
            return resolve();
          });
        } else {
          throw Error('Cannot transfer not transferable item');
        }
      });
    }
  }, {
    key: 'equip',
    value: function equip() {
      // this.equipped = true
      if (this.canEquip) {
        return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.dispatch('destiny/profile/equipItem', { item: this });
      } else {
        throw Error('Cannot equip not equipable item');
      }
    }
  }, {
    key: 'unEquip',
    value: function unEquip() {
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.dispatch('destiny/profile/unEquipItem', { item: this });
    }
  }, {
    key: 'lock',
    value: function lock() {
      if (this.canToggleLock) {
        return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.dispatch('destiny/profile/lockItem', { item: this });
      }
    }
  }, {
    key: 'unLock',
    value: function unLock() {
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.dispatch('destiny/profile/unLockItem', { item: this });
    }
  }, {
    key: 'hasTag',
    value: function hasTag(tag) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.tags[tag]).has(this.key);
    }
  }, {
    key: 'toggleTag',
    value: function toggleTag(tag) {
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.commit('toggleTag', { item: this, tag: tag });
    }
  }, {
    key: 'characterHash',
    get: function get() {
      if (this.definition.equippable) {
        return this._characterHash;
      }
      if (this.currentBucket.hash === 138197802) {
        return 'VAULT';
      } else {
        return 'INVENTORY';
      }
    },
    set: function set(value) {
      this._characterHash = value;
    }
  }, {
    key: 'equipped',
    get: function get() {
      return this.instance.isEquipped;
    }
  }, {
    key: 'key',
    get: function get() {
      return this.data.itemInstanceId;
    }
  }, {
    key: 'sources',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__Source__["a" /* getSources */])(this.data.itemHash) || [];
    }
  }, {
    key: 'icon',
    get: function get() {
      if (this.definition.displayProperties.icon) {
        return 'https://www.bungie.net' + this.definition.displayProperties.icon;
      }
      return '';
    }
  }, {
    key: 'name',
    get: function get() {
      return this.definition.displayProperties.name;
    }
  }, {
    key: 'categories',
    get: function get() {
      if (this.definition.itemCategoryHashes) {
        return this.definition.itemCategoryHashes.map(function (cat) {
          return __WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getCategory(cat);
        });
      }
    }
  }, {
    key: 'instance',
    get: function get() {
      if (this.data.itemInstanceId) {
        var instance = __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.destiny.profile.itemComponents.instances[this.data.itemInstanceId];
        if (!instance) {
          console.warning('no instance for ' + this.name + ' ' + this.data.itemInstanceId);
          return {};
        }
        return instance;
      }
      return {};
    }
  }, {
    key: 'damageType',
    get: function get() {
      if (this.instance.damageTypeHash) {
        return __WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getDamageType(this.instance.damageTypeHash);
      }
      return {};
    }
  }, {
    key: 'damageTypeIcon',
    get: function get() {
      if (this.damageType.displayProperties) {
        return '//www.bungie.net' + this.damageType.displayProperties.icon;
      }
    }
  }, {
    key: 'damageTypeName',
    get: function get() {
      if (this.damageType.displayProperties) {
        return this.damageType.displayProperties.name;
      }
      return '';
    }
  }, {
    key: 'primaryStat',
    get: function get() {
      if (this.instance.primaryStat) {
        return this.instance.primaryStat.value;
      }
      return 0;
    }
  }, {
    key: 'realPrimaryStat',
    get: function get() {
      if (this.primaryStat) {
        return this.primaryStat - (this.hasLegenderyMod ? 5 : 0);
      }
      return 0;
    }
  }, {
    key: 'character',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.getters['destiny/profile/getCharacter'](this.characterHash);
    }
  }, {
    key: 'definition',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getItemDefinition(this.data.itemHash);
    }
  }, {
    key: 'enabled',
    get: function get() {
      if (this.definition.redacted) {
        return false;
      }
      if (this.definition.nonTransferrable) {
        return false;
      }
      if (this.isLost) {
        // lost items
        return false;
      }
      return true;
    }
  }, {
    key: 'isLost',
    get: function get() {
      return this.data.bucketHash === 215593132;
    }
  }, {
    key: 'canToggleLock',
    get: function get() {
      return this.data.lockable;
    }
  }, {
    key: 'canEquip',
    get: function get() {
      return this.instance.canEquip;
    }
  }, {
    key: 'sockets',
    get: function get() {
      if (this.data.itemInstanceId) {
        var sockets = __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.destiny.profile.itemComponents.sockets[this.data.itemInstanceId];
        if (sockets) {
          return sockets.sockets.filter(function (socket) {
            return socket.plugHash;
          }).map(function (socket) {
            return new __WEBPACK_IMPORTED_MODULE_9__Socket__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getItemDefinition(socket.plugHash));
          });
        }
      }
      return [];
    }
  }, {
    key: 'displayableSockets',
    get: function get() {
      return this.sockets.filter(function (itemDefinition) {
        return itemDefinition.itemCategoryHashes.length && itemDefinition.itemCategoryHashes.indexOf(52) !== -1;
      });
    }
  }, {
    key: 'isTransferable',
    get: function get() {
      return this.canTransferTo(__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.destiny.profile.selectedCharacter);
    }
  }, {
    key: 'tierType',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getTierType(this.definition.inventory.tierTypeHash) || {};
    }
  }, {
    key: 'bucket',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getInventoryBucket(this.definition.inventory.bucketTypeHash);
    }
  }, {
    key: 'currentBucket',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getInventoryBucket(this.data.bucketHash);
    }
  }, {
    key: 'hasLegenderyMod',
    get: function get() {
      return this.sockets.find(function (socket) {
        return socket.inventory.tierTypeName === 'Legendary' && socket.itemCategoryHashes.indexOf(52) !== -1;
      }) !== undefined;
    }
  }, {
    key: 'isWeapon',
    get: function get() {
      return this.bucket.id === 1498876634 || this.bucket.id === 2465295065 || this.bucket.id === 2465295065;
    }
  }, {
    key: 'isArmor',
    get: function get() {
      return this.bucket.id === 3448274439 || this.bucket.id === 3551918588 || this.bucket.id === 14239492 || this.bucket.id === 20886954 || this.bucket.id === 1585787867;
    }
  }, {
    key: 'isImportant',
    get: function get() {
      return this.tierType.id === 2759499571 || this.tierType.id === 4008398120;
    }
  }, {
    key: 'tokens',
    get: function get() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(['on:' + this.character.className, 'tier:' + (this.tierType.displayProperties || {}).name || '', 'type:' + this.bucket.displayProperties.name, 'sub-type:' + this.definition.itemTypeDisplayName, this.isWeapon || this.isArmor ? 'importance:' + (this.isImportant ? 'important' : 'not-important') : '', this.isDuplicate ? 'duplicated' : 'different', this.isDuplicate ? this.isBestDuplicate ? 'best-duplicate' : 'worst-duplicate' : '', this.favorited ? 'favorited' : 'unfavorited', this.equipped ? 'equipped' : 'unequipped', this.isLocked ? 'state:locked' : 'state:unlocked', this.isWeapon ? 'meta:weapon' : 'meta:not-weapon', this.isArmor ? 'meta:armor' : 'meta:not-armor', this.isTransferable ? 'transferable' : 'untransferable'].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.categories.map(function (c) {
        return 'category:' + c.shortTitle;
      })), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.sockets.map(function (socket) {
        return 'mod:' + (socket.itemCategoryHashes.indexOf(52) !== -1 ? socket.inventory.tierTypeName + ':' : '') + socket.displayProperties.name;
      })), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.sources.map(function (set) {
        return 'source:' + stringToSlug(set);
      })), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.tags.map(function (tag) {
        return 'tag:' + stringToSlug(tag);
      }))).filter(function (token) {
        return token;
      }).map(function (token) {
        return token.toLowerCase().replace(/ /g, '-');
      }))));
    }
  }, {
    key: 'primaryStatDefinition',
    get: function get() {
      return this.definition.stats.primaryBaseStatHash;
    }
  }, {
    key: 'stats',
    get: function get() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.definition.stats.stats).map(function (stat) {
        return {
          value: stat.value,
          hash: stat.statHash,
          definition: __WEBPACK_IMPORTED_MODULE_8__utils_database__["a" /* default */].getStat(stat.statHash)
        };
      }).filter(function (stat) {
        return stat.value && stat.definition.displayProperties.name && stat.hash !== _this2.instance.primaryStat.statHash;
      }).sort(function (a, b) {
        return a.definition.index < b.definition.index ? -1 : 1;
      });
    }
  }, {
    key: 'favorited',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.getters.isFavorited && __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.getters.isFavorited({ item: this });
    }
  }, {
    key: 'isDuplicate',
    get: function get() {
      var _this3 = this;

      if (this._isDuplicated === undefined) {
        if (this.data.itemInstanceId) {
          this._isDuplicated = __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.destiny.profile.items.find(function (item) {
            return item.data.itemHash === _this3.data.itemHash && item.data.itemInstanceId !== _this3.data.itemInstanceId;
          }) !== undefined;
        } else {
          this._isDuplicated = false;
        }
      }
      return this._isDuplicated;
    }
  }, {
    key: 'isBestDuplicate',
    get: function get() {
      var _this4 = this;

      if (this.isDuplicate) {
        if (this._isBestDuplicate === undefined) {
          if (this.data.itemInstanceId) {
            this._isBestDuplicate = __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.destiny.profile.items.find(function (item) {
              return item.data.itemHash === _this4.data.itemHash && item.data.itemInstanceId !== _this4.data.itemInstanceId && _this4.primaryStat >= item.primaryStat;
            }) || false;
          } else {
            this._isBestDuplicate = true;
          }
        }
        return this._isBestDuplicate;
      }
      return undefined;
    }
  }, {
    key: 'siblings',
    get: function get() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.destiny.profile.items.filter(function (search) {
        return search.bucket === _this5.bucket && search.character === _this5.character;
      });
    }
  }, {
    key: 'isLocked',
    get: function get() {
      return (this.data.state & LOCK_FLAG) === 1;
    }
  }, {
    key: 'tags',
    get: function get() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].store.state.tagsDefinitions).filter(function (tag) {
        return _this6.hasTag(tag);
      });
    }
  }]);

  return Item;
}();

/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_database__ = __webpack_require__(51);





var _class = function () {
  function _class(data) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
      _this[key] = data[key];
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'categories',
    get: function get() {
      if (this.itemCategoryHashes) {
        return this.itemCategoryHashes.map(function (cat) {
          return __WEBPACK_IMPORTED_MODULE_3__utils_database__["a" /* default */].getCategory(cat);
        });
      }
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSources;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sourceData__ = __webpack_require__(181);




var itemIdToSource = __WEBPACK_IMPORTED_MODULE_2__sourceData__["a" /* default */].map(function (_ref) {
  var name = _ref.name,
      items = _ref.items;
  return items.map(function (item) {
    return [item, name];
  });
}).reduce(function (acc, i) {
  return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acc), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(i));
}, []).reduce(function (acc, _ref2) {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
      id = _ref3[0],
      name = _ref3[1];

  if (acc[id]) {
    acc[id].push(name);
  } else acc[id] = [name];
  return acc;
}, {});

function getSources(itemId) {
  return itemIdToSource[itemId];
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js_plugins_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_firebase__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_resource__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__storePlugin__ = __webpack_require__(211);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__storePlugin__["a" /* default */]);

__webpack_require__(213);
window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

function isTokenExpired(state) {
  return !state.auth.tokenExpiration || new Date() > new Date(state.auth.tokenExpiration - 5000);
}

function checkTokenExpired() {
  if (__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.auth.tokenExpiration) {
    if (isTokenExpired(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state)) {
      __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].dispatch('errors/pushError', { error: 'Session timed out, please login again' });
      __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].dispatch('auth/logout');
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'home' });
    }
  }
}

function configureVueResource() {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_resource__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = 'https://www.bungie.net/';
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
    request.headers.set('X-Api-Key', __WEBPACK_IMPORTED_MODULE_10__config__["a" /* API_KEY */]);
    var bungieToken = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.auth.bungieToken;
    if (bungieToken && request.url !== 'Platform/App/OAuth/Token/' && request.url !== 'Platform/App/GetAccessTokensFromCode/') {
      request.headers.set('Authorization', 'Bearer ' + bungieToken);
    }
    next();
  });
}

function configFirebase() {
  __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_8__utils_firebase__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.auth().onAuthStateChanged(function (user) {
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit('firebaseAuth/setUser', { user: user });
  });
}

function configAnalytics() {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
    id: "UA-105808229-1",
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
  });
}

function configRaven() {
  if (true) {
    __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.config("https://fd9a6c58beea4b6db5d69eb383291e12@sentry.io/219844").addPlugin(__WEBPACK_IMPORTED_MODULE_6_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
  }
}

function hasCorrectUserCredentials() {
  return __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state.auth.membershipId && !isTokenExpired(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].state);
}

function configTokenExpirationWatcher() {
  setInterval(checkTokenExpired, 1000);
}

var created = function created() {
  configureVueResource();
  configFirebase();
  configTokenExpirationWatcher();
  configAnalytics();
  configRaven();

  if (hasCorrectUserCredentials()) {
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].dispatch('destiny/load');
  }
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  created: created
});

/***/ }),
/* 336 */
/***/ (function(module, exports) {



/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginFromCode", function() { return loginFromCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(371);



var loginFromCode = function loginFromCode(_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var code = _ref2.code;

  return __WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* defaultBungieOAuth */].getTokens(code).then(function (token) {
    var payload = {
      bungieToken: token.access_token,
      membershipId: token.membership_id
    };
    commit('setBungieToken', payload);
    commit('setMembershipId', payload);
    var tokenExpiration = new Date().getTime() + token.expires_in * 1000;
    commit('setTokenExpiration', { tokenExpiration: tokenExpiration });
    return true;
  });
};

var login = function login(_ref3) {
  var commit = _ref3.commit;

  __WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* defaultBungieOAuth */].login();
};

var logout = function logout(_ref4) {
  var commit = _ref4.commit;

  commit('setBungieToken', { bungieToken: null });
  commit('setMembershipId', { membershipId: null });
  commit('setTokenExpiration', { tokenExpiration: false });
  commit('clearFetchedData', null, { root: true });
  __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ name: 'home' });
};

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bungieToken", function() { return bungieToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogged", function() { return isLogged; });
var bungieToken = function bungieToken(state) {
  return state.bungieToken;
};
var isLogged = function isLogged(state) {
  return state.bungieToken !== null;
};

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(340);




var state = {
  bungieToken: localStorage.getItem('bungieToken'),
  membershipId: localStorage.getItem('membershipId'),
  tokenExpiration: localStorage.getItem('tokenExpiration')
};

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBungieToken", function() { return setBungieToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTokenExpiration", function() { return setTokenExpiration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMembershipId", function() { return setMembershipId; });
function setLocalStorage(key, value) {
  if (value === null) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
}

var setBungieToken = function setBungieToken(state, _ref) {
  var bungieToken = _ref.bungieToken;

  state.bungieToken = bungieToken;
  setLocalStorage('bungieToken', bungieToken);
};

var setTokenExpiration = function setTokenExpiration(state, _ref2) {
  var tokenExpiration = _ref2.tokenExpiration;

  state.tokenExpiration = tokenExpiration;
  setLocalStorage('tokenExpiration', tokenExpiration);
};

var setMembershipId = function setMembershipId(state, _ref3) {
  var membershipId = _ref3.membershipId;

  state.membershipId = membershipId;
  setLocalStorage('membershipId', membershipId);
};

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadBungieAccount", function() { return loadBungieAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_exceptions__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(18);





var load = function load(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit('setLoading', { loading: 'Loading manifest' });
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([dispatch('manifest/load'), dispatch('loadBungieAccount').then(function (_ref2) {
    var membershipId = _ref2.membershipId,
        membershipType = _ref2.membershipType;

    return dispatch('profile/load', { membershipId: membershipId, membershipType: membershipType });
  })]).then(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        _ = _ref4[0],
        profilePostLoad = _ref4[1];

    profilePostLoad();
    commit('setLoading', { loading: false });
  }).catch(function (e) {
    commit('setLoading', { loading: false });
    dispatch('auth/logout', {}, { root: true });
  });
};

var loadBungieAccount = function loadBungieAccount(_ref5) {
  var commit = _ref5.commit,
      rootGetters = _ref5.rootGetters;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get('Platform/User/GetCurrentBungieAccount/').then(function (_ref6) {
      var response = _ref6.data;

      if (response['Message'] === 'Ok') {
        commit('setCurrentUser', { currentUser: response['Response']['bungieNetUser'] });
        commit('setDestinyMemberships', { destinyMemberships: response['Response']['destinyMemberships'] });
        commit('setCurrentDestinyMembershipIndex', { index: 0 });
        resolve(response.Response.destinyMemberships[0]);
      } else {
        throw new __WEBPACK_IMPORTED_MODULE_2__utils_exceptions__["a" /* BungieError */](response);
      }
    });
  });
};

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeTokens", function() { return computeTokens; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



var computeTokens = function computeTokens(_ref) {
  var commit = _ref.commit,
      rootGetters = _ref.rootGetters,
      state = _ref.state;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
    if (state.search.trim() === '') {
      commit('setTokens', { tokens: [] });
    }
    var lastToken = state.search.split(' ').pop().toLocaleLowerCase();
    var items = rootGetters['destiny/items'];
    var tokens = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(items.map(function (i) {
      return i.tokens;
    }).reduce(function (a, b) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(b));
    }, []).concat(items.map(function (i) {
      return i.name.toLowerCase();
    })).filter(function (token) {
      return token.indexOf(lastToken) !== -1;
    }).filter(function (token) {
      return state.search.indexOf(token) === -1;
    }).reduce(function (acc, v) {
      acc[v] = (acc[v] || 0) + 1;
      return acc;
    }, {})).sort(function (a, b) {
      return a[1] < b[1] ? 1 : -1;
    }).slice(0, 20);
    commit('setTokens', { tokens: tokens });
  });
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toExportable", function() { return toExportable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_FiltersCollection__ = __webpack_require__(64);


var toExportable = function toExportable(state) {
  return new __WEBPACK_IMPORTED_MODULE_0__domain_FiltersCollection__["a" /* default */](state).exportable;
};

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tools__ = __webpack_require__(182);





var DEFAULT_SEARCHES = ['legendary 250+', 'shotgun 100-200', 'vault', 'void power', 'common legs', 'rare modifications 1-2 characters', 'rare modifications 3+ vault'];

var state = {
  searches: JSON.parse(localStorage.getItem('searches') || 'false') || DEFAULT_SEARCHES,
  variousLabels: ['Duplicated', 'Different', 'Favorited', 'Unfavorited', 'Equipped', 'Unequipped', 'Transferable', 'Untransferable', 'Best duplicates', 'Worst duplicates'],
  ordering: 'Default'
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tools__["a" /* cleanFilters */])(state);

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSearch", function() { return updateSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCategories", function() { return updateCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSubtypes", function() { return updateSubtypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateRarity", function() { return updateRarity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateModsRarity", function() { return updateModsRarity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSets", function() { return updateSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSearches", function() { return updateSearches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOrdering", function() { return setOrdering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateDamageType", function() { return updateDamageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateVarious", function() { return updateVarious; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTokens", function() { return setTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyFilters", function() { return applyFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools__ = __webpack_require__(182);




var updateSearch = function updateSearch(state, _ref) {
  var search = _ref.search;

  state.search = search;
};

var updateCategories = function updateCategories(state, _ref2) {
  var categories = _ref2.categories;

  state.categories = categories;
};

var updateSubtypes = function updateSubtypes(state, _ref3) {
  var subtypes = _ref3.subtypes;

  state.subtypes = subtypes;
};

var updateRarity = function updateRarity(state, _ref4) {
  var rarity = _ref4.rarity;

  state.rarity = rarity;
};

var updateModsRarity = function updateModsRarity(state, _ref5) {
  var modsRarity = _ref5.modsRarity;

  state.modsRarity = modsRarity;
};

var updateSets = function updateSets(state, _ref6) {
  var sets = _ref6.sets;

  state.sets = sets;
};

var updateSearches = function updateSearches(state, _ref7) {
  var searches = _ref7.searches;

  state.searches = searches;
  localStorage.setItem('searches', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.searches));
};

var setOrdering = function setOrdering(state, _ref8) {
  var ordering = _ref8.ordering;

  state.ordering = ordering;
};

var updateDamageType = function updateDamageType(state, _ref9) {
  var damageType = _ref9.damageType;

  state.damageType = damageType;
};

var updateVarious = function updateVarious(state, _ref10) {
  var various = _ref10.various;

  state.various = various;
};

var setTokens = function setTokens(state, _ref11) {
  var tokens = _ref11.tokens;

  state.tokens = tokens;
};

var applyFilters = function applyFilters(state, _ref12) {
  var filters = _ref12.filters;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tools__["a" /* cleanFilters */])(state);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).forEach(function (key) {
    state[key] = filters[key];
  });
};

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loaded", function() { return loaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "items", function() { return items; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_orderings__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_FiltersCollection__ = __webpack_require__(64);



var loaded = function loaded(state) {
  return state.manifest.loaded && state.profile.loaded;
};
var items = function items(state, getters) {
  if (getters.loaded) {
    var _items = new __WEBPACK_IMPORTED_MODULE_1__domain_FiltersCollection__["a" /* default */](state.filters).filter(state.profile.items).sort(__WEBPACK_IMPORTED_MODULE_0__utils_orderings__["a" /* orderings */][state.filters.ordering]);
    return _items;
  }
  return [];
};

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manifest__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__(344);








var state = {
  currentUser: null,
  destinyMemberships: null,
  currentDestinyMembership: null,
  loading: false
};

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  modules: {
    filters: __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */],
    manifest: __WEBPACK_IMPORTED_MODULE_3__manifest__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_4__profile__["a" /* default */]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_database__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);




var load = function load(_ref) {
  var commit = _ref.commit,
      state = _ref.state,
      rootGetters = _ref.rootGetters,
      dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('Platform/Destiny2/Manifest/').then(function (_ref2) {
    var data = _ref2.data;

    commit('setLanguages', { languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.Response.mobileWorldContentPaths) });
    return __WEBPACK_IMPORTED_MODULE_1__utils_database__["a" /* default */].load(data.Response.version + '-' + state.language, data.Response.mobileWorldContentPaths[state.language] + '?orgin=' + location.origin, function (message) {
      commit('destiny/setLoading', { loading: message }, { root: true });
    }).then(function (database) {
      commit('setLoaded', { loaded: true });
    });
  });
};

/***/ }),
/* 349 */
/***/ (function(module, exports) {



/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(351);




var state = {
  language: localStorage.getItem('manifestLang') || 'en',
  languages: [],
  loaded: false
};

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLanguages", function() { return setLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoaded", function() { return setLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLanguage", function() { return setLanguage; });
var setLanguages = function setLanguages(state, _ref) {
  var languages = _ref.languages;

  state.languages = languages;
};

var setLoaded = function setLoaded(state, _ref2) {
  var loaded = _ref2.loaded;

  state.loaded = loaded;
};

var setLanguage = function setLanguage(state, _ref3) {
  var language = _ref3.language;

  localStorage.setItem('manifestLang', language);
  state.language = language;
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentUser", function() { return setCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDestinyMemberships", function() { return setDestinyMemberships; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentDestinyMembershipIndex", function() { return setCurrentDestinyMembershipIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoading", function() { return setLoading; });
var setCurrentUser = function setCurrentUser(state, _ref) {
  var currentUser = _ref.currentUser;

  state.currentUser = currentUser;
};

var setDestinyMemberships = function setDestinyMemberships(state, _ref2) {
  var destinyMemberships = _ref2.destinyMemberships;

  state.destinyMemberships = destinyMemberships;
};

var setCurrentDestinyMembershipIndex = function setCurrentDestinyMembershipIndex(state, _ref3) {
  var index = _ref3.index;

  state.currentDestinyMembership = state.destinyMemberships[index];
};

var setLoading = function setLoading(state, _ref4) {
  var loading = _ref4.loading;

  state.loading = loading;
};

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reload", function() { return reload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transferItem", function() { return transferItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transferItemToCharacter", function() { return transferItemToCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transferItemFromVault", function() { return transferItemFromVault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transferItemToVault", function() { return transferItemToVault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipItem", function() { return equipItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unEquipItem", function() { return unEquipItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lockItem", function() { return lockItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unLockItem", function() { return unLockItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_Character__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_Action__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_database__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_Item__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_orderings__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(18);










var processLoadedData = function processLoadedData(_ref) {
  var characterEquipment = _ref.characterEquipment,
      characterInventories = _ref.characterInventories,
      profileInventory = _ref.profileInventory;

  var processedCharacterItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(characterEquipment).concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(characterInventories)).reduce(function (acc, _ref2) {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
        characterHash = _ref3[0],
        data = _ref3[1];

    return acc.concat(data.items.map(function (itemData) {
      return new __WEBPACK_IMPORTED_MODULE_6__domain_Item__["a" /* default */](itemData, characterHash);
    }));
  }, []);
  var processedProfileInventory = profileInventory.items.map(function (itemData) {
    return new __WEBPACK_IMPORTED_MODULE_6__domain_Item__["a" /* default */](itemData, 'VAULT');
  });
  var result = processedCharacterItems.concat(processedProfileInventory).filter(function (item) {
    return item.enabled;
  });
  return result;
};

var load = function load(_ref4, _ref5) {
  var commit = _ref4.commit;
  var membershipId = _ref5.membershipId,
      membershipType = _ref5.membershipType;

  return __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].http.get('platform/Destiny2/' + membershipType + '/Profile/' + membershipId + '/?components=102,200,201,205,300,302,304,305,307,308') // ,301,302,303,304,305,306,307,308
  .then(function (_ref6) {
    var data = _ref6.data;

    var characters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(data.Response.characters.data).map(function (data) {
      return new __WEBPACK_IMPORTED_MODULE_3__domain_Character__["a" /* default */](data);
    });
    commit('setCharacters', { characters: characters });
    var lazyItems = function lazyItems() {
      var items = processLoadedData({
        characterEquipment: data.Response.characterEquipment.data,
        characterInventories: data.Response.characterInventories.data,
        profileInventory: data.Response.profileInventory.data
      });
      if (false) {
        window.items = items;
      }
      commit('setItems', { items: items });
    };
    var itemComponents = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data.Response.itemComponents).reduce(function (acc, _ref7) {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
          name = _ref8[0],
          data = _ref8[1].data;

      acc[name] = data;
      return acc;
    }, {});
    commit('setItemComponents', { itemComponents: itemComponents });
    commit('setLoaded', { loaded: true });
    return lazyItems;
  });
};

var reload = function reload(_ref9) {
  var commit = _ref9.commit,
      rootGetters = _ref9.rootGetters,
      rootState = _ref9.rootState;
  var _rootState$destiny$cu = rootState.destiny.currentDestinyMembership,
      membershipId = _rootState$destiny$cu.membershipId,
      membershipType = _rootState$destiny$cu.membershipType;

  commit('destiny/setLoading', { loading: 'Reloading inventory' }, { root: true });

  return __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].http.get('platform/Destiny2/' + membershipType + '/Profile/' + membershipId + '/?components=102,201,205,300,302,304,305,307,308') // ,301,302,303,304,305,306,307,308
  .then(function (_ref10) {
    var data = _ref10.data;

    var items = processLoadedData({
      characterEquipment: data.Response.characterEquipment.data,
      characterInventories: data.Response.characterInventories.data,
      profileInventory: data.Response.profileInventory.data
    });
    var itemComponents = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data.Response.itemComponents).reduce(function (acc, _ref11) {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
          name = _ref12[0],
          data = _ref12[1].data;

      acc[name] = data;
      return acc;
    }, {});

    return function () {
      commit('setItemComponents', { itemComponents: itemComponents });
      commit('setItems', { items: items });
      commit('destiny/setLoading', { loading: false }, { root: true });
    };
  }).catch(function (e) {
    commit('destiny/setLoading', { loading: false }, { root: true });
    throw e;
  });
};

var transferItem = function transferItem(_ref13, _ref14) {
  var state = _ref13.state,
      getters = _ref13.getters,
      dispatch = _ref13.dispatch;
  var item = _ref14.item,
      character = _ref14.character;

  var targetBucket = character.isVault ? __WEBPACK_IMPORTED_MODULE_5__utils_database__["a" /* default */].getInventoryBucket(character.bucketHash) : item.bucket;
  var targetBucketItems = getters.itemsByBucketForCurrentCharacter({ bucket: targetBucket });
  if (item.equipped) {
    item.unEquip();
  }
  if (targetBucket.itemCount > targetBucketItems.length + 1) {
    return dispatch('transferItemToCharacter', { item: item, character: character });
  } else if (!character.isVault) {
    var toGetRid = targetBucketItems.filter(function (item) {
      return !item.favorited && !item.equipped;
    }).sort(__WEBPACK_IMPORTED_MODULE_7__utils_orderings__["b" /* byTierType */]).pop();
    return dispatch('transferItemToCharacter', { item: toGetRid, character: item.character }).then(function () {
      return dispatch('transferItemToCharacter', { item: item, character: character });
    });
  } else {
    throw new Error('inventory full');
    /*
    const items = getters.itemsByTypeForCurrentCharacter({type: item.type})
      .sort(byTierType)
    if (state.selectedCharacter !== 'VAULT' && items.length === item.type.itemCount) {
      if (item.character.key === 'VAULT' || item.siblings.length < item.type.itemCount) {
        dispatch('transferItemToCharacter', {item: items[0], characterId: item.character.key})
      }
    }
    dispatch('transferItemToCharacter', {item, characterId: state.selectedCharacter})
    */
  }
};

var transferItemToCharacter = function transferItemToCharacter(_ref15, _ref16) {
  var state = _ref15.state,
      getters = _ref15.getters,
      dispatch = _ref15.dispatch;
  var item = _ref16.item,
      character = _ref16.character;

  if (character.isVault) {
    return dispatch('transferItemToVault', { item: item });
  } else if (item.character.isVault) {
    return dispatch('transferItemFromVault', { item: item, character: character });
  } else {
    return dispatch('transferItemToVault', { item: item, character: character }).then(function () {
      dispatch('transferItemFromVault', { item: item, character: character });
    });
  }
};

var transferItemFromVault = function transferItemFromVault(_ref17, _ref18) {
  var dispatch = _ref17.dispatch,
      rootState = _ref17.rootState,
      commit = _ref17.commit;
  var item = _ref18.item,
      character = _ref18.character;

  // const characterIndex = state.characters.map((character) => character.characterId).indexOf(characterId)
  commit('updateItemCharacter', { item: item, newCharacterId: character.characterId });
  // commit('updateItemCharacterIndex', {item: item, newCharacterIndex: characterIndex})

  return dispatch('queue/pushAction', {
    action: new __WEBPACK_IMPORTED_MODULE_4__domain_Action__["a" /* default */]({
      label: '<i class="material-icons">file_upload</i> Transfer <strong>' + item.name + '</strong> from vault',
      url: 'Platform/Destiny2/Actions/Items/TransferItem/',
      method: 'post',
      payload: {
        itemReferenceHash: item.data.itemHash,
        stackSize: 0,
        transferToVault: false,
        itemId: item.data.itemInstanceId,
        characterId: character.characterId,
        membershipType: rootState.destiny.currentDestinyMembership.membershipType
      }
    })
  }, { root: true });
};

var transferItemToVault = function transferItemToVault(_ref19, _ref20) {
  var dispatch = _ref19.dispatch,
      rootState = _ref19.rootState,
      commit = _ref19.commit,
      state = _ref19.state;
  var item = _ref20.item;

  var oldCharacterIndex = item.character.characterId;
  commit('updateItemCharacter', { item: item, newCharacterId: 'VAULT' });
  window.item = item;
  return dispatch('queue/pushAction', {
    action: new __WEBPACK_IMPORTED_MODULE_4__domain_Action__["a" /* default */]({
      label: '<i class="material-icons">file_download</i> Transfer <strong>' + item.name + '</strong> to vault',
      url: 'Platform/Destiny2/Actions/Items/TransferItem/',
      method: 'post',
      payload: {
        itemReferenceHash: item.data.itemHash,
        stackSize: item.data.itemInstanceId ? 0 : item.data.quantity,
        transferToVault: true,
        itemId: item.data.itemInstanceId,
        characterId: oldCharacterIndex !== 'INVENTORY' ? oldCharacterIndex : state.characters[0].characterId,
        membershipType: rootState.destiny.currentDestinyMembership.membershipType
      }
    })
  }, { root: true });
};

var equipItem = function equipItem(_ref21, _ref22) {
  var dispatch = _ref21.dispatch,
      state = _ref21.state,
      commit = _ref21.commit,
      rootState = _ref21.rootState;
  var item = _ref22.item;

  console.assert(item.canEquip, 'should be allowed to equip');
  var equipped = item.siblings.find(function (sibling) {
    return sibling.equipped;
  });
  commit('setUnequipped', { item: equipped });
  commit('setEquipped', { item: item });

  return dispatch('queue/pushAction', {
    action: new __WEBPACK_IMPORTED_MODULE_4__domain_Action__["a" /* default */]({
      label: '<i class="material-icons">bookmark</i> Equipping ' + item.name,
      url: 'Platform/Destiny2/Actions/Items/EquipItem/',
      method: 'post',
      payload: {
        itemId: item.data.itemInstanceId,
        characterId: item.character.characterId,
        membershipType: rootState.destiny.currentDestinyMembership.membershipType
      }
    })
  }, { root: true });
};

var unEquipItem = function unEquipItem(_ref23, _ref24) {
  var dispatch = _ref23.dispatch;
  var item = _ref24.item;

  var candidates = item.siblings.filter(function (sibiling) {
    return sibiling.canEquip && sibiling.key !== item.key;
  }).sort(__WEBPACK_IMPORTED_MODULE_7__utils_orderings__["b" /* byTierType */]);
  if (candidates.length) {
    return dispatch('equipItem', { item: candidates[0] });
  } else {
    throw Error('Cannot unequip ' + item.name + ', there is nothing to equip');
  }
};

var lockItem = function lockItem(_ref25, _ref26) {
  var dispatch = _ref25.dispatch,
      commit = _ref25.commit,
      rootState = _ref25.rootState;
  var item = _ref26.item;

  console.assert(item.canToggleLock, 'should be allowed to toggle lock');
  commit('setLocked', { item: item });

  return dispatch('queue/pushAction', {
    action: new __WEBPACK_IMPORTED_MODULE_4__domain_Action__["a" /* default */]({
      label: '<i class="material-icons">lock</i> Locking ' + item.name,
      url: 'Platform/Destiny2/Actions/Items/SetLockState/',
      method: 'post',
      payload: {
        itemId: item.data.itemInstanceId,
        characterId: item.character.characterId !== 'VAULT' ? item.character.characterId : null,
        membershipType: rootState.destiny.currentDestinyMembership.membershipType,
        state: 1
      }
    })
  }, { root: true });
};

var unLockItem = function unLockItem(_ref27, _ref28) {
  var dispatch = _ref27.dispatch,
      rootState = _ref27.rootState,
      commit = _ref27.commit;
  var item = _ref28.item;

  commit('setUnLocked', { item: item });
  return dispatch('queue/pushAction', {
    action: new __WEBPACK_IMPORTED_MODULE_4__domain_Action__["a" /* default */]({
      label: '<i class="material-icons">lock_open</i> Unlocking ' + item.name,
      url: 'Platform/Destiny2/Actions/Items/SetLockState/',
      method: 'post',
      payload: {
        itemId: item.data.itemInstanceId,
        characterId: item.character.characterId !== 'VAULT' ? item.character.characterId : null,
        membershipType: rootState.destiny.currentDestinyMembership.membershipType,
        state: 0
      }
    })
  }, { root: true });
};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCharacter", function() { return getCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentCharacter", function() { return getCurrentCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemsByBucketForCurrentCharacter", function() { return itemsByBucketForCurrentCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemsByBucket", function() { return itemsByBucket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allItemsCategories", function() { return allItemsCategories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var VAULT = {
  race: {
    raceName: ''
  },
  gender: {
    genderName: ''
  },
  className: 'Vault',
  emblemPath: 'https://www.bungie.net/common/destiny_content/icons/971ab9229b8164aff89c7801f332b54c.jpg',
  emblemBackgroundPath: 'https://www.bungie.net/common/destiny_content/icons/61d32219f2ce198d6295c65554a64808.jpg',
  characterId: 'VAULT',
  bucketHash: 138197802,
  isVault: true
};

var INVENTORY = {
  race: {
    raceName: ''
  },
  gender: {
    genderName: ''
  },
  className: 'Characters',
  emblemPath: 'https://www.bungie.net/common/destiny_content/icons/971ab9229b8164aff89c7801f332b54c.jpg',
  emblemBackgroundPath: 'https://www.bungie.net/common/destiny_content/icons/61d32219f2ce198d6295c65554a64808.jpg',
  characterId: 'INVENTORY',
  bucketHash: 138197802,
  isVault: true
};

var getCharacter = function getCharacter(state) {
  return function (characterId) {
    if (state.characters) {
      if (characterId === 'VAULT') {
        return VAULT;
      } else if (characterId === 'INVENTORY') {
        return INVENTORY;
      }
      return state.characters.find(function (character) {
        return character.characterId === characterId;
      });
    }
  };
};

var getCurrentCharacter = function getCurrentCharacter(state, getters) {
  return getters.getCharacter(state.selectedCharacter);
};

var itemsByBucketForCurrentCharacter = function itemsByBucketForCurrentCharacter(state, getters) {
  return function (_ref) {
    var bucket = _ref.bucket;

    if (state.selectedCharacter === 'VAULT') {
      // vault is one large bucket
      return state.items.filter(function (item) {
        return item.character.characterId === 'VAULT';
      });
    }
    return getters.itemsByBucket({ bucket: bucket, characterId: state.selectedCharacter });
  };
};

var itemsByBucket = function itemsByBucket(state, getters) {
  return function (_ref2) {
    var bucket = _ref2.bucket,
        characterId = _ref2.characterId;

    return state.items.filter(function (item) {
      return item.bucket === bucket && item.character.characterId === characterId;
    });
  };
};

var allItemsCategories = function allItemsCategories(state) {
  return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(state.items.map(function (item) {
    return item.bucket;
  }))));
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(356);




var state = {
  characters: null,
  loaded: false,
  selectedCharacter: null,
  items: [],
  itemComponents: null
};

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCharacters", function() { return setCharacters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoaded", function() { return setLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItems", function() { return setItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectCharacter", function() { return selectCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCharacterEquipment", function() { return setCharacterEquipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCharacterInventories", function() { return setCharacterInventories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProfileInventory", function() { return setProfileInventory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemComponents", function() { return setItemComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateItemCharacter", function() { return updateItemCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUnequipped", function() { return setUnequipped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEquipped", function() { return setEquipped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUnLocked", function() { return setUnLocked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLocked", function() { return setLocked; });
var setCharacters = function setCharacters(state, _ref) {
  var characters = _ref.characters;

  state.characters = characters;
};

var setLoaded = function setLoaded(state, _ref2) {
  var loaded = _ref2.loaded;

  state.loaded = loaded;
};

var setItems = function setItems(state, _ref3) {
  var items = _ref3.items;

  state.items = items;
};

var selectCharacter = function selectCharacter(state, _ref4) {
  var selectedCharacter = _ref4.selectedCharacter;

  state.selectedCharacter = selectedCharacter;
};

var setCharacterEquipment = function setCharacterEquipment(state, _ref5) {
  var characterEquipment = _ref5.characterEquipment;

  state.characterEquipment = characterEquipment;
};

var setCharacterInventories = function setCharacterInventories(state, _ref6) {
  var characterInventories = _ref6.characterInventories;

  state.characterInventories = characterInventories;
};
var setProfileInventory = function setProfileInventory(state, _ref7) {
  var profileInventory = _ref7.profileInventory;

  state.profileInventory = profileInventory;
};

var setItemComponents = function setItemComponents(state, _ref8) {
  var itemComponents = _ref8.itemComponents;

  state.itemComponents = itemComponents;
};

var updateItemCharacter = function updateItemCharacter(state, _ref9) {
  var item = _ref9.item,
      newCharacterId = _ref9.newCharacterId;

  state.items.find(function (searched) {
    return searched.data.itemInstanceId === item.data.itemInstanceId;
  }).characterHash = newCharacterId;
};

var setUnequipped = function setUnequipped(state, _ref10) {
  var item = _ref10.item;

  item.instance.isEquipped = false;
};

var setEquipped = function setEquipped(state, _ref11) {
  var item = _ref11.item;

  item.instance.isEquipped = true;
};

var setUnLocked = function setUnLocked(state, _ref12) {
  var item = _ref12.item;

  item.data.state = 0;
};

var setLocked = function setLocked(state, _ref13) {
  var item = _ref13.item;

  item.data.state = 1;
};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushError", function() { return pushError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popError", function() { return popError; });
var pushError = function pushError(_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var error = _ref2.error;

  commit('pushError', { error: error });
  setTimeout(function () {
    dispatch('popError');
  }, 1500);
};

var popError = function popError(_ref3) {
  var state = _ref3.state,
      commit = _ref3.commit;

  if (state.errors.length) {
    commit('popError');
  }
};

/***/ }),
/* 358 */
/***/ (function(module, exports) {



/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(360);




var state = {
  errors: []
};

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushError", function() { return pushError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popError", function() { return popError; });
var pushError = function pushError(state, _ref) {
  var error = _ref.error;

  state.errors.push(error);
};

var popError = function popError(state) {
  state.errors.shift();
};

/***/ }),
/* 361 */
/***/ (function(module, exports) {



/***/ }),
/* 362 */
/***/ (function(module, exports) {



/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(364);




var state = {
  user: false
};

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return setUser; });
var setUser = function setUser(state, _ref) {
  var user = _ref.user;

  state.user = user;
};

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFavorited", function() { return isFavorited; });

var isFavorited = function isFavorited(state) {
  return function (_ref) {
    var item = _ref.item;

    return state.favorites.indexOf(item.key) !== -1;
  };
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDestinyAccounts", function() { return setDestinyAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectCharacter", function() { return selectCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearFetchedData", function() { return clearFetchedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItems", function() { return setItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateItemCharacterIndex", function() { return updateItemCharacterIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lockItem", function() { return lockItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unLockItem", function() { return unLockItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEquipped", function() { return setEquipped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUnequipped", function() { return setUnequipped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favoriteItem", function() { return favoriteItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unFavoriteItem", function() { return unFavoriteItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFavorities", function() { return setFavorities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTagsDefinitions", function() { return updateTagsDefinitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTagDefinition", function() { return setTagDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTagDefinition", function() { return deleteTagDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleTag", function() { return toggleTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTags", function() { return updateTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(18);








var setDestinyAccounts = function setDestinyAccounts(state, _ref) {
  var destinyAccounts = _ref.destinyAccounts;

  state.destinyAccounts = destinyAccounts;
};

var selectCharacter = function selectCharacter(state, _ref2) {
  var characterId = _ref2.characterId;

  state.selectedCharacter = characterId;
};

var clearFetchedData = function clearFetchedData(state) {
  state.currentUser = null;
  state.destinyAccounts = null;
  state.currentDestinyMembership = null;
  state.destinyMemberships = null;
  state.characters = null;
  state.selectedCharacter = null;
  state.items = null;
  state.filter = {
    search: ''
  };
};

var setItems = function setItems(state, _ref3) {
  var items = _ref3.items;

  state.items = items;
};

var updateItemCharacterIndex = function updateItemCharacterIndex(state, _ref4) {
  var item = _ref4.item,
      newCharacterIndex = _ref4.newCharacterIndex;

  state.items.find(function (searched) {
    return searched.data.itemId === item.data.itemId;
  }).data.characterIndex = newCharacterIndex;
};

var lockItem = function lockItem(state, _ref5) {
  var item = _ref5.item;

  state.items.find(function (searched) {
    return searched.data.itemId === item.data.itemId;
  }).data.state = 1;
};

var unLockItem = function unLockItem(state, _ref6) {
  var item = _ref6.item;

  state.items.find(function (searched) {
    return searched.data.itemId === item.data.itemId;
  }).data.state = 0;
};

var setEquipped = function setEquipped(state, _ref7) {
  var item = _ref7.item;

  state.items.find(function (searched) {
    return searched.data.itemId === item.data.itemId;
  }).data.transferStatus = 1;
};

var setUnequipped = function setUnequipped(state, _ref8) {
  var item = _ref8.item;

  state.items.find(function (searched) {
    return searched.data.itemId === item.data.itemId;
  }).data.transferStatus = 0;
};

var favoriteItem = function favoriteItem(state, _ref9) {
  var item = _ref9.item;

  state.favorites = state.favorites.filter(function (i) {
    return i !== item.key;
  }).concat([item.key]);
  localStorage.setItem('favorites', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.favorites));
};

var unFavoriteItem = function unFavoriteItem(state, _ref10) {
  var item = _ref10.item;

  state.favorites = state.favorites.filter(function (i) {
    return i !== item.key;
  });
  localStorage.setItem('favorites', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.favorites));
};
var setFavorities = function setFavorities(state, _ref11) {
  var favorities = _ref11.favorities;

  state.favorites = favorities;
  localStorage.setItem('favorites', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.favorites));
};

var updateTagsDefinitions = function updateTagsDefinitions(state, _ref12) {
  var tagsDefinitions = _ref12.tagsDefinitions;

  state.tagsDefinitions = tagsDefinitions;
  localStorage.setItem('tagsDefinitions', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.tagsDefinitions));
};

var setTagDefinition = function setTagDefinition(state, _ref13) {
  var tag = _ref13.tag,
      color = _ref13.color;

  __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.tagsDefinitions, tag, { 'color': color });
  localStorage.setItem('tagsDefinitions', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.tagsDefinitions));
};

var deleteTagDefinition = function deleteTagDefinition(state, tag) {
  state.tagsDefinitions = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(state.tagsDefinitions).filter(function (_ref14) {
    var _ref15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref14, 2),
        needle = _ref15[0],
        _ = _ref15[1];

    return needle !== tag;
  }).reduce(function (acc, _ref16) {
    var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref16, 2),
        tag = _ref17[0],
        definition = _ref17[1];

    acc[tag] = definition;
    return acc;
  }, {});
  localStorage.setItem('tagsDefinitions', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.tagsDefinitions));
};

var toggleTag = function toggleTag(state, _ref18) {
  var item = _ref18.item,
      tag = _ref18.tag;

  var current = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(state.tags[tag] || []);
  if (current.has(item.key)) {
    current.delete(item.key);
  } else {
    current.add(item.key);
  }
  var obj = [];
  obj[tag] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(current));
  state.tags = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.tags, obj);
  localStorage.setItem('tags', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.tags));
};

var updateTags = function updateTags(state, _ref19) {
  var tags = _ref19.tags;

  state.tags = tags;
  localStorage.setItem('tags', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.tags));
};

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushAction", function() { return pushAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consumeQueue", function() { return consumeQueue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);


/**
 * Store action in queue
 * @param commit
 * @param action
 * @returns {Promise}
 */
var pushAction = function pushAction(_ref, _ref2) {
  var commit = _ref.commit,
      state = _ref.state,
      dispatch = _ref.dispatch;
  var action = _ref2.action;

  oldSentry = null;
  if (reloadTimeout) {
    clearTimeout(reloadTimeout);
  }
  commit('pushAction', { action: action });
  if (!state.isWorking) {
    commit('setIsWorking');
    dispatch('consumeQueue');
  }
};

var oldSentry = null;
var reloadTimeout = null;

var consumeQueue = function consumeQueue(_ref3) {
  var commit = _ref3.commit,
      state = _ref3.state,
      dispatch = _ref3.dispatch,
      rootGetters = _ref3.rootGetters;

  console.assert(state.isWorking, 'Should work to comsume');
  if (state.queue.length) {
    var action = state.queue.shift();
    commit('setCurrentActionMessage', { message: action.label + ' - ' + state.queue.length + ' left' });
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http[action.method](action.url, action.payload).then(function (_ref4) {
      var response = _ref4.data;

      if (response['Message'] !== 'Ok') {
        if (response.ErrorStatus === 'WebAuthModuleAsyncFailed') {
          dispatch('logout', null, { root: true });
        } else {
          dispatch('errors/pushError', { error: response.Message }, { root: true });
          console.error('Error: ', response.Message);
        }
      }
      dispatch('consumeQueue');
    }).catch(function () {
      dispatch('consumeQueue');
    });
  } else {
    commit('unsetIsWorking');
    commit('setCurrentActionMessage', { message: '' });
    var sentry = oldSentry = '' + Math.random();
    reloadTimeout = setTimeout(function () {
      dispatch('destiny/profile/reload', null, { root: true }).then(function (commitReload) {
        if (!state.isWorking && sentry === oldSentry) {
          commitReload();
          commit('setCurrentActionMessage', { message: '' });
        }
      });
    }, 2000);
  }
};

/***/ }),
/* 368 */
/***/ (function(module, exports) {



/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(370);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* default */]);





var state = {
  queue: [],
  currentActionMessage: '',
  isWorking: false
};

var store = {
  namespaced: true,
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushAction", function() { return pushAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIsWorking", function() { return setIsWorking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unsetIsWorking", function() { return unsetIsWorking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentActionMessage", function() { return setCurrentActionMessage; });
var pushAction = function pushAction(state, _ref) {
  var action = _ref.action;

  state.queue.push(action);
};

var setIsWorking = function setIsWorking(state) {
  console.assert(!state.isWorking, 'should not work');
  state.isWorking = true;
};
var unsetIsWorking = function unsetIsWorking(state) {
  console.assert(state.isWorking, 'should work');
  state.isWorking = false;
};

var setCurrentActionMessage = function setCurrentActionMessage(state, _ref2) {
  var message = _ref2.message;

  if (message) {
    console.debug('Current action: ', message);
  }
  state.currentActionMessage = message;
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BungieOAuth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultBungieOAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(133);




var version = 1;

var BungieOAuth = function () {
  function BungieOAuth(clientId) {
    var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : localStorage;
    var goToUrlCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (url) {
      window.location = url;
    };

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BungieOAuth);

    this.clientId = clientId;
    this.storage = storage;
    this.goToUrlCallback = goToUrlCallback;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BungieOAuth, [{
    key: 'login',
    value: function login() {
      this.goToUrlCallback('https://www.bungie.net/en/OAuth/Authorize?client_id=' + this.clientId + '&response_type=code');
    }
  }, {
    key: 'getTokens',
    value: function getTokens(accessCode) {
      if (version === 2) {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('Platform/App/GetAccessTokensFromCode/', { 'code': accessCode }).then(function (response) {
          console.log(response);
          return response.data;
        });
      }

      var data = 'client_id=' + this.clientId + '&grant_type=authorization_code&code=' + accessCode;
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post('Platform/App/OAuth/Token/', data, {
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return BungieOAuth;
}();



var defaultBungieOAuth = new BungieOAuth(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* OAUTH_CLIENT_ID */]);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BungieError;
function BungieError(response) {
  this.name = 'BungieApiError';
  this.response = response;
}

BungieError.prototype = Error.prototype;

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoLanguages; });
var isoLanguages = {
  'ab': {
    'name': 'Abkhaz',
    'nativeName': 'аҧсуа'
  },
  'aa': {
    'name': 'Afar',
    'nativeName': 'Afaraf'
  },
  'af': {
    'name': 'Afrikaans',
    'nativeName': 'Afrikaans'
  },
  'ak': {
    'name': 'Akan',
    'nativeName': 'Akan'
  },
  'sq': {
    'name': 'Albanian',
    'nativeName': 'Shqip'
  },
  'am': {
    'name': 'Amharic',
    'nativeName': 'አማርኛ'
  },
  'ar': {
    'name': 'Arabic',
    'nativeName': 'العربية'
  },
  'an': {
    'name': 'Aragonese',
    'nativeName': 'Aragonés'
  },
  'hy': {
    'name': 'Armenian',
    'nativeName': 'Հայերեն'
  },
  'as': {
    'name': 'Assamese',
    'nativeName': 'অসমীয়া'
  },
  'av': {
    'name': 'Avaric',
    'nativeName': 'авар мацӀ, магӀарул мацӀ'
  },
  'ae': {
    'name': 'Avestan',
    'nativeName': 'avesta'
  },
  'ay': {
    'name': 'Aymara',
    'nativeName': 'aymar aru'
  },
  'az': {
    'name': 'Azerbaijani',
    'nativeName': 'azərbaycan dili'
  },
  'bm': {
    'name': 'Bambara',
    'nativeName': 'bamanankan'
  },
  'ba': {
    'name': 'Bashkir',
    'nativeName': 'башҡорт теле'
  },
  'eu': {
    'name': 'Basque',
    'nativeName': 'euskara, euskera'
  },
  'be': {
    'name': 'Belarusian',
    'nativeName': 'Беларуская'
  },
  'bn': {
    'name': 'Bengali',
    'nativeName': 'বাংলা'
  },
  'bh': {
    'name': 'Bihari',
    'nativeName': 'भोजपुरी'
  },
  'bi': {
    'name': 'Bislama',
    'nativeName': 'Bislama'
  },
  'bs': {
    'name': 'Bosnian',
    'nativeName': 'bosanski jezik'
  },
  'br': {
    'name': 'Breton',
    'nativeName': 'brezhoneg'
  },
  'bg': {
    'name': 'Bulgarian',
    'nativeName': 'български език'
  },
  'my': {
    'name': 'Burmese',
    'nativeName': 'ဗမာစာ'
  },
  'ca': {
    'name': 'Catalan; Valencian',
    'nativeName': 'Català'
  },
  'ch': {
    'name': 'Chamorro',
    'nativeName': 'Chamoru'
  },
  'ce': {
    'name': 'Chechen',
    'nativeName': 'нохчийн мотт'
  },
  'ny': {
    'name': 'Chichewa; Chewa; Nyanja',
    'nativeName': 'chiCheŵa, chinyanja'
  },
  'zh': {
    'name': 'Chinese',
    'nativeName': '中文 (Zhōngwén), 汉语, 漢語'
  },
  'cv': {
    'name': 'Chuvash',
    'nativeName': 'чӑваш чӗлхи'
  },
  'kw': {
    'name': 'Cornish',
    'nativeName': 'Kernewek'
  },
  'co': {
    'name': 'Corsican',
    'nativeName': 'corsu, lingua corsa'
  },
  'cr': {
    'name': 'Cree',
    'nativeName': 'ᓀᐦᐃᔭᐍᐏᐣ'
  },
  'hr': {
    'name': 'Croatian',
    'nativeName': 'hrvatski'
  },
  'cs': {
    'name': 'Czech',
    'nativeName': 'česky, čeština'
  },
  'da': {
    'name': 'Danish',
    'nativeName': 'dansk'
  },
  'dv': {
    'name': 'Divehi; Dhivehi; Maldivian;',
    'nativeName': 'ދިވެހި'
  },
  'nl': {
    'name': 'Dutch',
    'nativeName': 'Nederlands, Vlaams'
  },
  'en': {
    'name': 'English',
    'nativeName': 'English'
  },
  'eo': {
    'name': 'Esperanto',
    'nativeName': 'Esperanto'
  },
  'et': {
    'name': 'Estonian',
    'nativeName': 'eesti, eesti keel'
  },
  'ee': {
    'name': 'Ewe',
    'nativeName': 'Eʋegbe'
  },
  'fo': {
    'name': 'Faroese',
    'nativeName': 'føroyskt'
  },
  'fj': {
    'name': 'Fijian',
    'nativeName': 'vosa Vakaviti'
  },
  'fi': {
    'name': 'Finnish',
    'nativeName': 'suomi, suomen kieli'
  },
  'fr': {
    'name': 'French',
    'nativeName': 'français, langue française'
  },
  'ff': {
    'name': 'Fula; Fulah; Pulaar; Pular',
    'nativeName': 'Fulfulde, Pulaar, Pular'
  },
  'gl': {
    'name': 'Galician',
    'nativeName': 'Galego'
  },
  'ka': {
    'name': 'Georgian',
    'nativeName': 'ქართული'
  },
  'de': {
    'name': 'German',
    'nativeName': 'Deutsch'
  },
  'el': {
    'name': 'Greek, Modern',
    'nativeName': 'Ελληνικά'
  },
  'gn': {
    'name': 'Guaraní',
    'nativeName': 'Avañeẽ'
  },
  'gu': {
    'name': 'Gujarati',
    'nativeName': 'ગુજરાતી'
  },
  'ht': {
    'name': 'Haitian; Haitian Creole',
    'nativeName': 'Kreyòl ayisyen'
  },
  'ha': {
    'name': 'Hausa',
    'nativeName': 'Hausa, هَوُسَ'
  },
  'he': {
    'name': 'Hebrew (modern)',
    'nativeName': 'עברית'
  },
  'hz': {
    'name': 'Herero',
    'nativeName': 'Otjiherero'
  },
  'hi': {
    'name': 'Hindi',
    'nativeName': 'हिन्दी, हिंदी'
  },
  'ho': {
    'name': 'Hiri Motu',
    'nativeName': 'Hiri Motu'
  },
  'hu': {
    'name': 'Hungarian',
    'nativeName': 'Magyar'
  },
  'ia': {
    'name': 'Interlingua',
    'nativeName': 'Interlingua'
  },
  'id': {
    'name': 'Indonesian',
    'nativeName': 'Bahasa Indonesia'
  },
  'ie': {
    'name': 'Interlingue',
    'nativeName': 'Originally called Occidental; then Interlingue after WWII'
  },
  'ga': {
    'name': 'Irish',
    'nativeName': 'Gaeilge'
  },
  'ig': {
    'name': 'Igbo',
    'nativeName': 'Asụsụ Igbo'
  },
  'ik': {
    'name': 'Inupiaq',
    'nativeName': 'Iñupiaq, Iñupiatun'
  },
  'io': {
    'name': 'Ido',
    'nativeName': 'Ido'
  },
  'is': {
    'name': 'Icelandic',
    'nativeName': 'Íslenska'
  },
  'it': {
    'name': 'Italian',
    'nativeName': 'Italiano'
  },
  'iu': {
    'name': 'Inuktitut',
    'nativeName': 'ᐃᓄᒃᑎᑐᑦ'
  },
  'ja': {
    'name': 'Japanese',
    'nativeName': '日本語 (にほんご／にっぽんご)'
  },
  'jv': {
    'name': 'Javanese',
    'nativeName': 'basa Jawa'
  },
  'kl': {
    'name': 'Kalaallisut, Greenlandic',
    'nativeName': 'kalaallisut, kalaallit oqaasii'
  },
  'kn': {
    'name': 'Kannada',
    'nativeName': 'ಕನ್ನಡ'
  },
  'kr': {
    'name': 'Kanuri',
    'nativeName': 'Kanuri'
  },
  'ks': {
    'name': 'Kashmiri',
    'nativeName': 'कश्मीरी, كشميري‎'
  },
  'kk': {
    'name': 'Kazakh',
    'nativeName': 'Қазақ тілі'
  },
  'km': {
    'name': 'Khmer',
    'nativeName': 'ភាសាខ្មែរ'
  },
  'ki': {
    'name': 'Kikuyu, Gikuyu',
    'nativeName': 'Gĩkũyũ'
  },
  'rw': {
    'name': 'Kinyarwanda',
    'nativeName': 'Ikinyarwanda'
  },
  'ky': {
    'name': 'Kirghiz, Kyrgyz',
    'nativeName': 'кыргыз тили'
  },
  'kv': {
    'name': 'Komi',
    'nativeName': 'коми кыв'
  },
  'kg': {
    'name': 'Kongo',
    'nativeName': 'KiKongo'
  },
  'ko': {
    'name': 'Korean',
    'nativeName': '한국어 (韓國語), 조선말 (朝鮮語)'
  },
  'ku': {
    'name': 'Kurdish',
    'nativeName': 'Kurdî, كوردی‎'
  },
  'kj': {
    'name': 'Kwanyama, Kuanyama',
    'nativeName': 'Kuanyama'
  },
  'la': {
    'name': 'Latin',
    'nativeName': 'latine, lingua latina'
  },
  'lb': {
    'name': 'Luxembourgish, Letzeburgesch',
    'nativeName': 'Lëtzebuergesch'
  },
  'lg': {
    'name': 'Luganda',
    'nativeName': 'Luganda'
  },
  'li': {
    'name': 'Limburgish, Limburgan, Limburger',
    'nativeName': 'Limburgs'
  },
  'ln': {
    'name': 'Lingala',
    'nativeName': 'Lingála'
  },
  'lo': {
    'name': 'Lao',
    'nativeName': 'ພາສາລາວ'
  },
  'lt': {
    'name': 'Lithuanian',
    'nativeName': 'lietuvių kalba'
  },
  'lu': {
    'name': 'Luba-Katanga',
    'nativeName': ''
  },
  'lv': {
    'name': 'Latvian',
    'nativeName': 'latviešu valoda'
  },
  'gv': {
    'name': 'Manx',
    'nativeName': 'Gaelg, Gailck'
  },
  'mk': {
    'name': 'Macedonian',
    'nativeName': 'македонски јазик'
  },
  'mg': {
    'name': 'Malagasy',
    'nativeName': 'Malagasy fiteny'
  },
  'ms': {
    'name': 'Malay',
    'nativeName': 'bahasa Melayu, بهاس ملايو‎'
  },
  'ml': {
    'name': 'Malayalam',
    'nativeName': 'മലയാളം'
  },
  'mt': {
    'name': 'Maltese',
    'nativeName': 'Malti'
  },
  'mi': {
    'name': 'Māori',
    'nativeName': 'te reo Māori'
  },
  'mr': {
    'name': 'Marathi (Marāṭhī)',
    'nativeName': 'मराठी'
  },
  'mh': {
    'name': 'Marshallese',
    'nativeName': 'Kajin M̧ajeļ'
  },
  'mn': {
    'name': 'Mongolian',
    'nativeName': 'монгол'
  },
  'na': {
    'name': 'Nauru',
    'nativeName': 'Ekakairũ Naoero'
  },
  'nv': {
    'name': 'Navajo, Navaho',
    'nativeName': 'Diné bizaad, Dinékʼehǰí'
  },
  'nb': {
    'name': 'Norwegian Bokmål',
    'nativeName': 'Norsk bokmål'
  },
  'nd': {
    'name': 'North Ndebele',
    'nativeName': 'isiNdebele'
  },
  'ne': {
    'name': 'Nepali',
    'nativeName': 'नेपाली'
  },
  'ng': {
    'name': 'Ndonga',
    'nativeName': 'Owambo'
  },
  'nn': {
    'name': 'Norwegian Nynorsk',
    'nativeName': 'Norsk nynorsk'
  },
  'no': {
    'name': 'Norwegian',
    'nativeName': 'Norsk'
  },
  'ii': {
    'name': 'Nuosu',
    'nativeName': 'ꆈꌠ꒿ Nuosuhxop'
  },
  'nr': {
    'name': 'South Ndebele',
    'nativeName': 'isiNdebele'
  },
  'oc': {
    'name': 'Occitan',
    'nativeName': 'Occitan'
  },
  'oj': {
    'name': 'Ojibwe, Ojibwa',
    'nativeName': 'ᐊᓂᔑᓈᐯᒧᐎᓐ'
  },
  'cu': {
    'name': 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
    'nativeName': 'ѩзыкъ словѣньскъ'
  },
  'om': {
    'name': 'Oromo',
    'nativeName': 'Afaan Oromoo'
  },
  'or': {
    'name': 'Oriya',
    'nativeName': 'ଓଡ଼ିଆ'
  },
  'os': {
    'name': 'Ossetian, Ossetic',
    'nativeName': 'ирон æвзаг'
  },
  'pa': {
    'name': 'Panjabi, Punjabi',
    'nativeName': 'ਪੰਜਾਬੀ, پنجابی‎'
  },
  'pi': {
    'name': 'Pāli',
    'nativeName': 'पाऴि'
  },
  'fa': {
    'name': 'Persian',
    'nativeName': 'فارسی'
  },
  'pl': {
    'name': 'Polish',
    'nativeName': 'polski'
  },
  'ps': {
    'name': 'Pashto, Pushto',
    'nativeName': 'پښتو'
  },
  'pt': {
    'name': 'Portuguese',
    'nativeName': 'Português'
  },
  'qu': {
    'name': 'Quechua',
    'nativeName': 'Runa Simi, Kichwa'
  },
  'rm': {
    'name': 'Romansh',
    'nativeName': 'rumantsch grischun'
  },
  'rn': {
    'name': 'Kirundi',
    'nativeName': 'kiRundi'
  },
  'ro': {
    'name': 'Romanian, Moldavian, Moldovan',
    'nativeName': 'română'
  },
  'ru': {
    'name': 'Russian',
    'nativeName': 'русский язык'
  },
  'sa': {
    'name': 'Sanskrit (Saṁskṛta)',
    'nativeName': 'संस्कृतम्'
  },
  'sc': {
    'name': 'Sardinian',
    'nativeName': 'sardu'
  },
  'sd': {
    'name': 'Sindhi',
    'nativeName': 'सिन्धी, سنڌي، سندھی‎'
  },
  'se': {
    'name': 'Northern Sami',
    'nativeName': 'Davvisámegiella'
  },
  'sm': {
    'name': 'Samoan',
    'nativeName': 'gagana faa Samoa'
  },
  'sg': {
    'name': 'Sango',
    'nativeName': 'yângâ tî sängö'
  },
  'sr': {
    'name': 'Serbian',
    'nativeName': 'српски језик'
  },
  'gd': {
    'name': 'Scottish Gaelic; Gaelic',
    'nativeName': 'Gàidhlig'
  },
  'sn': {
    'name': 'Shona',
    'nativeName': 'chiShona'
  },
  'si': {
    'name': 'Sinhala, Sinhalese',
    'nativeName': 'සිංහල'
  },
  'sk': {
    'name': 'Slovak',
    'nativeName': 'slovenčina'
  },
  'sl': {
    'name': 'Slovene',
    'nativeName': 'slovenščina'
  },
  'so': {
    'name': 'Somali',
    'nativeName': 'Soomaaliga, af Soomaali'
  },
  'st': {
    'name': 'Southern Sotho',
    'nativeName': 'Sesotho'
  },
  'es': {
    'name': 'Spanish; Castilian',
    'nativeName': 'Español, (Castellano)'
  },
  'es-mx': {
    'name': 'Spanish (Mexico)',
    'nativeName': 'Español (México)'
  },
  'su': {
    'name': 'Sundanese',
    'nativeName': 'Basa Sunda'
  },
  'sw': {
    'name': 'Swahili',
    'nativeName': 'Kiswahili'
  },
  'ss': {
    'name': 'Swati',
    'nativeName': 'SiSwati'
  },
  'sv': {
    'name': 'Swedish',
    'nativeName': 'svenska'
  },
  'ta': {
    'name': 'Tamil',
    'nativeName': 'தமிழ்'
  },
  'te': {
    'name': 'Telugu',
    'nativeName': 'తెలుగు'
  },
  'tg': {
    'name': 'Tajik',
    'nativeName': 'тоҷикӣ, toğikī, تاجیکی‎'
  },
  'th': {
    'name': 'Thai',
    'nativeName': 'ไทย'
  },
  'ti': {
    'name': 'Tigrinya',
    'nativeName': 'ትግርኛ'
  },
  'bo': {
    'name': 'Tibetan Standard, Tibetan, Central',
    'nativeName': 'བོད་ཡིག'
  },
  'tk': {
    'name': 'Turkmen',
    'nativeName': 'Türkmen, Түркмен'
  },
  'tl': {
    'name': 'Tagalog',
    'nativeName': 'Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔'
  },
  'tn': {
    'name': 'Tswana',
    'nativeName': 'Setswana'
  },
  'to': {
    'name': 'Tonga (Tonga Islands)',
    'nativeName': 'faka Tonga'
  },
  'tr': {
    'name': 'Turkish',
    'nativeName': 'Türkçe'
  },
  'ts': {
    'name': 'Tsonga',
    'nativeName': 'Xitsonga'
  },
  'tt': {
    'name': 'Tatar',
    'nativeName': 'татарча, tatarça, تاتارچا‎'
  },
  'tw': {
    'name': 'Twi',
    'nativeName': 'Twi'
  },
  'ty': {
    'name': 'Tahitian',
    'nativeName': 'Reo Tahiti'
  },
  'ug': {
    'name': 'Uighur, Uyghur',
    'nativeName': 'Uyƣurqə, ئۇيغۇرچە‎'
  },
  'uk': {
    'name': 'Ukrainian',
    'nativeName': 'українська'
  },
  'ur': {
    'name': 'Urdu',
    'nativeName': 'اردو'
  },
  'uz': {
    'name': 'Uzbek',
    'nativeName': 'zbek, Ўзбек, أۇزبېك‎'
  },
  've': {
    'name': 'Venda',
    'nativeName': 'Tshivenḓa'
  },
  'vi': {
    'name': 'Vietnamese',
    'nativeName': 'Tiếng Việt'
  },
  'vo': {
    'name': 'Volapük',
    'nativeName': 'Volapük'
  },
  'wa': {
    'name': 'Walloon',
    'nativeName': 'Walon'
  },
  'cy': {
    'name': 'Welsh',
    'nativeName': 'Cymraeg'
  },
  'wo': {
    'name': 'Wolof',
    'nativeName': 'Wollof'
  },
  'fy': {
    'name': 'Western Frisian',
    'nativeName': 'Frysk'
  },
  'xh': {
    'name': 'Xhosa',
    'nativeName': 'isiXhosa'
  },
  'yi': {
    'name': 'Yiddish',
    'nativeName': 'ייִדיש'
  },
  'yo': {
    'name': 'Yoruba',
    'nativeName': 'Yorùbá'
  },
  'za': {
    'name': 'Zhuang, Chuang',
    'nativeName': 'Saɯ cueŋƅ, Saw cuengh'
  }
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hashCode; });
var hashCode = function hashCode(s) {
  var hash = 0;
  if (s.length === 0) return hash;
  for (var i = 0; i < s.length; i++) {
    hash = (hash << 5) - hash + s.charCodeAt(i);
    hash |= 0;
  }
  return hash;
};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavBar__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_NavBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CurrentAction__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CurrentAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CurrentAction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Errors__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoadingScreen__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LoadingScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LoadingScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_social_sharing__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_social_sharing__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: {},
  data: function data() {
    return {
      footerVisible: true
    };
  },

  components: {
    NavBar: __WEBPACK_IMPORTED_MODULE_0__components_NavBar___default.a,
    CurrentAction: __WEBPACK_IMPORTED_MODULE_1__components_CurrentAction___default.a,
    Errors: __WEBPACK_IMPORTED_MODULE_2__components_Errors___default.a,
    LoadingScreen: __WEBPACK_IMPORTED_MODULE_3__components_LoadingScreen___default.a,
    SocialSharing: __WEBPACK_IMPORTED_MODULE_4_vue_social_sharing___default.a
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'account-selector',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isLogged']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['currentDestinyAccount']), {
    displayName: function displayName() {
      return this.$store.state.currentDestinyMembership.displayName;
    },
    shouldShow: function shouldShow() {
      return this.isLogged && this.$store.state.currentDestinyAccount && this.$store.state.currentDestinyAccount && this.$store.state.destinyAccounts.length > 1;
    }
  }),
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['login'])
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Emblem__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Emblem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Emblem__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['characterId', 'opened'],
  name: 'panels',
  data: function data() {
    return {};
  },

  computed: {
    character: function character() {
      return this.$store.getters['destiny/profile/getCharacter'](this.characterId);
    },
    isSelected: function isSelected() {
      return this.characterId === this.$store.state.destiny.profile.selectedCharacter;
    }
  },
  components: {
    Emblem: __WEBPACK_IMPORTED_MODULE_0__components_Emblem___default.a
  },
  methods: {
    onSelect: function onSelect() {
      this.$emit('selected', this.characterId);
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Checkboxes',
  props: ['items', 'model', 'label', 'collapsable', 'prefix', 'type'],
  data: function data() {
    return {
      pinned: false,
      dragged: false,
      visible: false,
      myModel: this.mode,
      top: '40px',
      left: '40px'
    };
  },

  computed: {
    selectedItems: function selectedItems() {
      var _this = this;

      return this.items.filter(function (item) {
        return _this.model.indexOf(item.hash) !== -1;
      }).map(function (item) {
        return item.name;
      }).join(', ');
    }
  },
  mounted: function mounted() {
    window.document.body.addEventListener('mouseup', this.onMouseUp);
    window.document.body.addEventListener('mousemove', this.onMouseMove);
  },
  beforeDestroy: function beforeDestroy() {
    window.document.body.removeEventListener('mouseup', this.onMouseUp);
    window.document.body.removeEventListener('mousemove', this.onMouseMove);
  },

  methods: {
    onMouseDown: function onMouseDown(e) {
      if (this.pinned) {
        this.dragged = {
          dy: e.clientY - this.$refs.movable.getBoundingClientRect().y,
          dx: e.clientX - this.$refs.movable.getBoundingClientRect().x
        };
      }
    },
    onMouseUp: function onMouseUp() {
      this.dragged = false;
    },
    onMouseMove: function onMouseMove(_ref) {
      var clientX = _ref.clientX,
          clientY = _ref.clientY;

      if (this.dragged) {
        this.top = clientY - this.dragged.dy + 'px';
        this.left = clientX - this.dragged.dx + 'px';
      }
    },
    toggleVisible: function toggleVisible() {
      if (!this.pinned) {
        this.visible = !this.visible;
      }
    },
    togglePinned: function togglePinned(_ref2) {
      var target = _ref2.target;

      this.left = this.$refs.movable.offsetLeft + 'px';
      this.pinned = !this.pinned;
      this.visible = this.pinned;
    },
    key: function key(category) {
      return 'category-' + (this.prefix || '') + category.hash;
    },

    updateValue: function updateValue(value) {
      if (this.model.indexOf(parseInt(value)) === -1) {
        if (this.type === 'checkbox') {
          this.$emit('updated', [parseInt(value)].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.model)));
        } else {
          this.$emit('updated', [parseInt(value)]);
        }
      } else {
        if (this.type === 'checkbox') {
          var newFilter = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.model));
          newFilter.splice(this.model.indexOf(parseInt(value)), 1);
          this.$emit('updated', newFilter);
        } else {
          this.$emit('updated', []);
        }
      }
    }
  },
  components: {}
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'current-action',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('queue', ['queue', 'isWorking', 'currentActionMessage']))
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FontSizeTracker__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FontSizeTracker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FontSizeTracker__);
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'emblem',
  data: function data() {
    return {};
  },

  props: ['character'],
  computed: {
    styleObject: function styleObject() {
      return {
        backgroundImage: 'url(' + this.character.emblemBackgroundPath + ')'
      };
    }
  },
  components: {
    FontSizeTracker: __WEBPACK_IMPORTED_MODULE_0__components_FontSizeTracker___default.a
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'errors',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('errors', ['errors'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('errors', ['popError']))
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_FiltersCollection__ = __webpack_require__(64);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FavoritedSearches',
  props: ['collapsable'],
  data: function data() {
    return {
      searchesVisible: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('destiny/filters', ['searches'])),
  methods: {
    decodeExportable: function decodeExportable(exportable) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_3__domain_FiltersCollection__["a" /* default */].fromExportable(exportable).displayValues);
    },
    deleteSearch: function deleteSearch(toDelete) {
      this.$store.commit('destiny/filters/updateSearches', {
        searches: this.searches.filter(function (needle) {
          return needle !== toDelete;
        })
      });
    },
    applyFilter: function applyFilter(exportable) {
      this.$store.commit('destiny/filters/applyFilters', { filters: __WEBPACK_IMPORTED_MODULE_3__domain_FiltersCollection__["a" /* default */].fromExportable(exportable).cleanFilters });
    }
  },
  components: {}
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Checkboxes__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Checkboxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Checkboxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tokens__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Search__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FavoritedSearches_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FavoritedSearches_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_FavoritedSearches_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_FiltersCollection__ = __webpack_require__(64);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'filters',
  props: {
    collapsable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      exportFilterVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    exportable: 'destiny/filters/toExportable'
  }), {
    filtersCollection: function filtersCollection() {
      return new __WEBPACK_IMPORTED_MODULE_7__domain_FiltersCollection__["a" /* default */](this.$store.state.destiny.filters);
    },
    filters: function filters() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.filtersCollection.filters).filter(function (fa) {
        return fa.label;
      });
    }
  }),
  methods: {
    focusSearch: function focusSearch() {
      // TODO: implement
    }
  },
  components: {
    FavoritedSearches: __WEBPACK_IMPORTED_MODULE_6__components_FavoritedSearches_vue___default.a,
    Checkboxes: __WEBPACK_IMPORTED_MODULE_2__components_Checkboxes___default.a,
    Tokens: __WEBPACK_IMPORTED_MODULE_3__components_Tokens___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_4__components_Search___default.a
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'firebaseAuth',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('firebaseAuth', ['user'])),
  methods: {
    doLogin: function doLogin() {
      var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth.GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithRedirect(provider);
    },
    doLogout: function doLogout() {
      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut();
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'font-size-tracker',
  data: function data() {
    return {
      height: 0
    };
  },

  methods: {
    checkSize: function checkSize() {
      if (this.heigth !== this.$el.offsetHeight && this.$el.offsetHeight > 10) {
        this.heigth = this.$el.offsetHeight;
        this.$el.style.fontSize = this.$el.offsetHeight + 'px';
      }
    }
  },
  mounted: function mounted() {
    this.checkSize();
    this.resizeCheck = setInterval(this.checkSize, 500);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.resizeCheck);
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'template'
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TagsSelector_vue__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TagsSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TagsSelector_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { TagsSelector: __WEBPACK_IMPORTED_MODULE_0__TagsSelector_vue___default.a },
  name: 'item',
  props: ['item', 'character'],
  data: function data() {
    return {
      transfering: false,
      tagsSelectorVisible: false
    };
  },

  computed: {
    background: function background() {
      var _this = this;

      var background = this.item.isTransferable ? '#34404d' : '#2A333E';
      var tags = this.item.tags;
      if (tags.length) {
        var gradient = this.item.tags.map(function (tag) {
          return _this.tagColor(tag);
        }).reduce(function (acc, cur) {
          acc.push(cur);
          acc.push(cur);
          return acc;
        }, []).concat(background).map(function (color, i) {
          return color + ' ' + Math.ceil(i / 2) * 10 + 'px';
        }).join(',');
        var back = 'linear-gradient(-45deg, ' + gradient + ')';
        return back;
      } else {
        return background;
      }
    },
    transferTarget: function transferTarget() {
      var targetCharacter = this.character || this.$store.state.destiny.profile.selectedCharacter;
      return this.$store.getters['destiny/profile/getCharacter'](targetCharacter);
    }
  },
  methods: {
    tagColor: function tagColor(tag) {
      return this.$store.state.tagsDefinitions[tag].color;
    },
    transferItem: function transferItem() {
      var _this2 = this;

      if (this.transferTarget && this.item.canTransferTo(this.transferTarget.characterId)) {
        this.item.transfer(this.transferTarget).then(function () {
          _this2.$ga.event({
            eventCategory: 'item',
            eventAction: 'transferItem',
            eventLabel: _this2.item.name,
            eventValue: 1
          });
        }).catch(function (error) {
          _this2.$store.dispatch('errors/pushError', { error: error.message });
        });
      }
    },
    equip: function equip() {
      var _this3 = this;

      this.item.equip().then(function () {
        _this3.$ga.event({
          eventCategory: 'item',
          eventAction: 'equipItem',
          eventLabel: _this3.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this3.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    unEquip: function unEquip() {
      var _this4 = this;

      this.item.unEquip().then(function () {
        _this4.$ga.event({
          eventCategory: 'item',
          eventAction: 'unEquipItem',
          eventLabel: _this4.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this4.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    lock: function lock() {
      var _this5 = this;

      this.item.lock().then(function () {
        _this5.$ga.event({
          eventCategory: 'item',
          eventAction: 'lockItem',
          eventLabel: _this5.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this5.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    unLock: function unLock() {
      var _this6 = this;

      this.item.unLock().then(function () {
        _this6.$ga.event({
          eventCategory: 'item',
          eventAction: 'unLockItem',
          eventLabel: _this6.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this6.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    favorite: function favorite() {
      this.$store.commit('favoriteItem', { item: this.item });
      this.$ga.event({
        eventCategory: 'item',
        eventAction: 'favorite',
        eventLabel: this.item.name,
        eventValue: 1
      });
    },
    unFavorite: function unFavorite() {
      this.$store.commit('unFavoriteItem', { item: this.item });
      this.$ga.event({
        eventCategory: 'item',
        eventAction: 'unFavorite',
        eventLabel: this.item.name,
        eventValue: 1
      });
    },
    showTagsSelector: function showTagsSelector() {
      this.tagsSelectorVisible = true;
    },
    debugItem: function debugItem() {
      window.item = this.item;
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Item__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-list',
  data: function data() {
    return {
      position: 20,
      busy: false
    };
  },

  computed: {
    items: function items() {
      return this.$store.getters['destiny/items'].slice(0, this.position);
    }
  },
  methods: {
    loadMore: function loadMore() {
      this.busy = false;
      this.position += 10;
    },
    onScroll: function onScroll(e) {
      if (this.oldOnScroll) {
        this.oldOnScroll(e);
      }
      if ((e.pageY || (document.scrollingElement || {}).scrollTop) + window.innerHeight * 3 > this.$el.offsetTop + this.$el.offsetHeight) {
        this.position += 10;
      }
    }
  },
  components: { Item: __WEBPACK_IMPORTED_MODULE_0__components_Item___default.a },
  directives: { infiniteScroll: __WEBPACK_IMPORTED_MODULE_1_vue_infinite_scroll___default.a },
  created: function created() {
    var _this = this;

    this.storeWatcher = this.$store.watch(function (state) {
      return _this.$store.getters['destiny/items'];
    }, function (newVal) {
      _this.position = 20;
    });
  },
  mounted: function mounted() {
    this.oldOnScroll = document.body.onscroll;
    document.body.onscroll = this.onScroll;
  },
  beforeDestroy: function beforeDestroy() {
    document.body.onscroll = this.oldOnScroll;
    this.storeWatcher();
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loadingScreen',
  props: [],
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('destiny', ['loading'])),
  methods: {},
  components: {}
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Item_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LockPanel',
  props: ['title', 'subtitle', 'items', 'notMatched'],
  data: function data() {
    return {
      previewItems: []
    };
  },

  computed: {
    itemsToLock: function itemsToLock() {
      return this.items.filter(function (item) {
        return !item.isLocked;
      });
    },
    itemsToUnlock: function itemsToUnlock() {
      return this.items.filter(function (item) {
        return item.isLocked;
      });
    },
    notMatchedItems: function notMatchedItems() {
      return this.notMatched.filter(function (item) {
        return item.isLocked;
      });
    }
  },
  methods: {
    doLock: function doLock() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(this.itemsToLock.map(function (item) {
        return _this.$store.dispatch('destiny/profile/lockItem', { item: item });
      }));
    },
    doUnlock: function doUnlock(itemsToUnlock) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(itemsToUnlock.map(function (item) {
        return _this2.$store.dispatch('destiny/profile/unLockItem', { item: item });
      }));
    }
  },
  components: { Item: __WEBPACK_IMPORTED_MODULE_1__Item_vue___default.a }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_orderings__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AccountSelector__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AccountSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AccountSelector__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav-bar',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['isLogged']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('firebaseAuth', ['user']), {
    profilePicturePath: function profilePicturePath() {
      if (this.$store.state.destiny.currentUser) {
        return 'https://www.bungie.net' + this.$store.state.destiny.currentUser.profilePicturePath;
      }
      return false;
    },
    username: function username() {
      if (this.$store.state.currentUser) {
        return this.$store.state.currentUser.displayName;
      }
    },

    ordering: {
      get: function get() {
        return this.$store.state.destiny.filters.ordering;
      },
      set: function set(value) {
        this.$store.commit('destiny/filters/setOrdering', { ordering: value });
      }
    },
    allOrderings: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__utils_orderings__["a" /* orderings */]);
      }
    }
  }),
  methods: {
    handleLogin: function handleLogin() {
      this.$store.dispatch('auth/login');
    },
    handleLogout: function handleLogout() {
      var _this = this;

      this.$store.dispatch('auth/logout').then(function () {
        return _this.$router.push({ name: 'home' });
      });
    },
    handleRefresh: function handleRefresh() {
      var _this2 = this;

      this.$store.dispatch('destiny/profile/reload').then(function (reloadCommit) {
        reloadCommit();
        _this2.$store.commit('queue/setCurrentActionMessage', { message: '' });
      });
    },
    toggleFilter: function toggleFilter() {
      if (this.$route.name === 'filter') {
        this.$router.back();
      } else {
        this.$router.push({ 'name': 'filter' });
      }
    }
  },
  components: {
    AccountSelector: __WEBPACK_IMPORTED_MODULE_4__components_AccountSelector___default.a
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CharacterPanel__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CharacterPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CharacterPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sticky__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Sticky__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'panels',
  data: function data() {
    return {
      opened: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('destiny/profile', ['characters'])),
  methods: {
    openMenu: function openMenu() {
      this.opened = true;
    },
    onSelected: function onSelected(characterId) {
      this.opened = false;
      this.$router.push({
        name: 'manager',
        params: { character: characterId }
      });
    }
  },
  components: {
    CharacterPanel: __WEBPACK_IMPORTED_MODULE_2__components_CharacterPanel___default.a,
    Sticky: __WEBPACK_IMPORTED_MODULE_3__components_Sticky___default.a
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_FiltersCollection__ = __webpack_require__(64);


//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  props: [],
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    exportable: 'destiny/filters/toExportable'
  }), {
    search: {
      get: function get() {
        return this.$store.state.destiny.filters.search;
      },
      set: function set(search) {
        this.updateSearch(this.$store, search);
      }
    },
    searches: function searches() {
      return this.$store.state.destiny.filters.searches;
    },
    canAddSearch: function canAddSearch() {
      return this.searches.indexOf(this.exportable) === -1;
    },
    hasFilter: function hasFilter() {
      var fc = new __WEBPACK_IMPORTED_MODULE_4__domain_FiltersCollection__["a" /* default */](this.$store.state.destiny.filters);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(fc.cleanFilters).length;
    }
  }),
  methods: {
    clearSearch: function clearSearch() {
      this.$store.commit('destiny/filters/applyFilters', { filters: {} });
    },

    updateSearch: __WEBPACK_IMPORTED_MODULE_2_underscore___default.a.debounce(function (store, search) {
      store.commit('destiny/filters/updateSearch', { search: search });
    }, 200),
    deleteSearch: function deleteSearch(toDelete) {
      this.$store.commit('destiny/filters/updateSearches', {
        searches: this.searches.filter(function (needle) {
          return needle !== toDelete;
        })
      });
    },
    addSearch: function addSearch(toAdd) {
      this.$store.commit('destiny/filters/updateSearches', {
        searches: this.searches.concat([toAdd])
      });
    }
  },
  components: {}
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sticky',
  data: function data() {
    return {
      fixed: false
    };
  },

  methods: {
    onScroll: function onScroll() {
      this.fixed = document.body.scrollTop > this.$el.offsetTop;
    },
    checkSize: function checkSize() {
      var sizer = this.$el.getElementsByClassName('sizer')[0];
      var source = this.$el.getElementsByClassName('source')[0];
      if (source && sizer) {
        sizer.style.height = source.offsetHeight + 'px';
      }
    }
  },
  mounted: function mounted() {
    if (document.body.onscroll) {
      var old = document.body.onscroll;
      var new_ = this.onScroll;
      document.body.onscroll = function (e) {
        old(e);
        new_(e);
      };
    } else {
      document.body.onscroll = this.onScroll;
    }
    this.checkSize();
    this.resizeCheck = setInterval(this.checkSize, 500);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.resizeCheck);
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tagsEditor',
  props: [],
  data: function data() {
    return {
      'newTag': ''
    };
  },

  computed: {
    tagsDefinitions: function tagsDefinitions() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.$store.state.tagsDefinitions);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])(['deleteTagDefinition']), {
    addTagDefinition: function addTagDefinition(tag) {
      this.$store.commit('setTagDefinition', {
        tag: tag,
        color: '#' + Math.floor(Math.random() * Math.pow(2, 8 * 3)).toString(16)
      });
      this.newTag = '';
    },
    setTagDefinition: function setTagDefinition(tag, color) {
      this.$store.commit('setTagDefinition', { tag: tag, color: color });
    }
  }),
  components: {}
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tagsSelector',
  props: ['item'],
  data: function data() {
    return {};
  },

  computed: {
    tagsDefinitions: function tagsDefinitions() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.$store.state.tagsDefinitions);
    },
    targets: function targets() {
      return this.$store.state.destiny.profile.characters.concat([this.$store.getters['destiny/profile/getCharacter']('VAULT')]);
    }
  },
  methods: {
    toggleTag: function toggleTag(tag) {
      this.item.toggleTag(tag);
      this.$ga.event({
        eventCategory: 'item',
        eventAction: 'toggleTag',
        eventLabel: this.item.name,
        eventValue: tag
      });
    },
    equip: function equip() {
      var _this = this;

      this.item.equip().then(function () {
        _this.$ga.event({
          eventCategory: 'item',
          eventAction: 'equipItem',
          eventLabel: _this.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    unEquip: function unEquip() {
      var _this2 = this;

      this.item.unEquip().then(function () {
        _this2.$ga.event({
          eventCategory: 'item',
          eventAction: 'unEquipItem',
          eventLabel: _this2.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this2.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    lock: function lock() {
      var _this3 = this;

      this.item.lock().then(function () {
        _this3.$ga.event({
          eventCategory: 'item',
          eventAction: 'lockItem',
          eventLabel: _this3.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this3.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    unLock: function unLock() {
      var _this4 = this;

      this.item.unLock().then(function () {
        _this4.$ga.event({
          eventCategory: 'item',
          eventAction: 'unLockItem',
          eventLabel: _this4.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this4.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    favorite: function favorite() {
      this.$store.commit('favoriteItem', { item: this.item });
      this.$ga.event({
        eventCategory: 'item',
        eventAction: 'favorite',
        eventLabel: this.item.name,
        eventValue: 1
      });
    },
    unFavorite: function unFavorite() {
      this.$store.commit('unFavoriteItem', { item: this.item });
      this.$ga.event({
        eventCategory: 'item',
        eventAction: 'unFavorite',
        eventLabel: this.item.name,
        eventValue: 1
      });
    }
  },
  components: {}
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tokens',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('destiny/filters', ['search', 'tokens'])),
  methods: {
    applyToken: function applyToken(newToken) {
      var tokens = this.$store.state.destiny.filters.search.split(' ');
      var search = (tokens.slice(0, tokens.length - 1).join(' ') + ' ' + newToken).trim();
      this.$store.commit('destiny/filters/updateSearch', { search: search });
      this.$emit('applied', newToken);
    }
  },
  components: {}
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Item_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransferPanel',
  props: ['title', 'subtitle', 'items', 'targets', 'sources', 'color'],
  data: function data() {
    return {
      previewItems: [],
      currentCharacter: null
    };
  },

  computed: {
    headerExtraStyle: function headerExtraStyle() {
      if (this.color) {
        return { 'backgroundColor': this.color };
      }
      return {};
    },
    allSources: function allSources() {
      return this.sources || [{ 'className': 'Transfer' }];
    },
    allItemsCount: function allItemsCount() {
      var _this = this;

      return this.targets.filter(function (target) {
        return target;
      }).map(function (target) {
        return target.characterId;
      }).map(function (characterId) {
        return _this.itemsToTransfer(characterId).length;
      }).reduce(function (acc, i) {
        return acc + i;
      }, 0);
    }
  },
  methods: {
    itemsToTransfer: function itemsToTransfer(characterId, sourceId) {
      var items = this.items.filter(function (item) {
        return item.canTransferTo(characterId);
      });
      if (sourceId) {
        return items.filter(function (item) {
          return item.characterHash === sourceId;
        });
      }
      return items;
    },
    preview: function preview(characterId, sourceId) {
      this.currentCharacter = characterId;
      this.previewItems = this.itemsToTransfer(characterId, sourceId);
      console.log('pi', this.previewItems);
    },
    transfer: function transfer(target, sourceId) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(this.itemsToTransfer(target.characterId, sourceId).map(function (item) {
        return item.transfer(target);
      }));
    }
  },
  components: { Item: __WEBPACK_IMPORTED_MODULE_1__Item_vue___default.a }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auth',
  data: function data() {
    return {
      isError: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('auth/loginFromCode', { code: this.$route.query.code }).then(function () {
      _this.$store.dispatch('destiny/load');
      _this.$router.push({ name: 'home' });
    }).catch(function () {
      _this.isError = true;
    });
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Filters_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Filters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Filters_vue__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'template',
  props: [],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: { Filters: __WEBPACK_IMPORTED_MODULE_0__components_Filters_vue___default.a }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Panels__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Panels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Panels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemList__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ItemList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ItemList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Help__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_social_sharing__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_social_sharing__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content',
  data: function data() {
    return {};
  },

  computed: {},
  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('auth', ['login']),
  components: { Panels: __WEBPACK_IMPORTED_MODULE_1__components_Panels___default.a, ItemList: __WEBPACK_IMPORTED_MODULE_2__components_ItemList___default.a, Help: __WEBPACK_IMPORTED_MODULE_3__components_Help___default.a, SocialSharing: __WEBPACK_IMPORTED_MODULE_4_vue_social_sharing___default.a },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('social_shares_open', function (network, url) {
      _this.$ga.event({
        eventCategory: 'share',
        eventAction: 'open',
        eventLabel: network,
        eventValue: 1
      });
    });
    this.$root.$on('social_shares_close', function (network, url) {
      _this.$ga.event({
        eventCategory: 'share',
        eventAction: 'close',
        eventLabel: network,
        eventValue: 1
      });
    });
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ItemDetail',
  props: ['instanceId'],
  data: function data() {
    return {};
  },

  computed: {
    item: function item() {
      var _this = this;

      var item = this.$store.state.destiny.profile.items.find(function (item) {
        return item.data.itemInstanceId === _this.instanceId;
      });
      if (false) {
        window.item = item;
      }
      return item;
    }
  },
  methods: {
    equip: function equip() {
      var _this2 = this;

      this.item.equip().then(function () {
        _this2.$ga.event({
          eventCategory: 'item',
          eventAction: 'equipItem',
          eventLabel: _this2.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this2.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    unEquip: function unEquip() {
      var _this3 = this;

      this.item.unEquip().then(function () {
        _this3.$ga.event({
          eventCategory: 'item',
          eventAction: 'unEquipItem',
          eventLabel: _this3.item.name,
          eventValue: 1
        });
      }).catch(function (error) {
        _this3.$store.dispatch('errors/pushError', { error: error.message });
      });
    },
    searchToken: function searchToken(newSearch) {
      this.$store.commit('destiny/filters/updateSearch', { search: newSearch });
      this.$router.back();
    },
    favorite: function favorite() {
      this.$store.commit('favoriteItem', { item: this.item });
      this.$ga.event({
        eventCategory: 'item',
        eventAction: 'favorite',
        eventLabel: this.item.name,
        eventValue: 1
      });
    },
    unFavorite: function unFavorite() {
      this.$store.commit('unFavoriteItem', { item: this.item });
      this.$ga.event({
        eventCategory: 'item',
        eventAction: 'unFavorite',
        eventLabel: this.item.name,
        eventValue: 1
      });
    }
  },
  components: {}
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('destiny/profile', ['characters'])),
  watch: {
    characters: function characters(newCharacters) {
      if (newCharacters) {
        this.$router.push({
          name: 'manager',
          params: { character: newCharacters[0].key }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.characters && this.characters.length) {
      this.$router.push({
        name: 'manager',
        params: { character: this.characters[0].key }
      });
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Panels__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Panels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Panels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ItemList__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ItemList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ItemList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Filters__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Filters__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('destiny', ['loaded'])),
  components: { Panels: __WEBPACK_IMPORTED_MODULE_2__components_Panels___default.a, ItemList: __WEBPACK_IMPORTED_MODULE_3__components_ItemList___default.a, Filters: __WEBPACK_IMPORTED_MODULE_4__components_Filters___default.a },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm) {
        vm.$store.commit('destiny/profile/selectCharacter', { selectedCharacter: to.params.character });
      }
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$store.commit('destiny/profile/selectCharacter', { selectedCharacter: to.params.character });
    next();
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_languages__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FirebaseAuth_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FirebaseAuth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FirebaseAuth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagsEditor_vue__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagsEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TagsEditor_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'template',
  props: [],
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    languageOptions: function languageOptions() {
      return this.languages.map(function (languageCode) {
        return {
          code: languageCode,
          name: (__WEBPACK_IMPORTED_MODULE_2__utils_languages__["a" /* isoLanguages */][languageCode] || __WEBPACK_IMPORTED_MODULE_2__utils_languages__["a" /* isoLanguages */][languageCode.split('-')[0]]).nativeName
        };
      });
    },

    language: {
      get: function get() {
        return this.$store.state.destiny.manifest.language;
      },
      set: function set(language) {
        this.$store.commit('destiny/manifest/setLanguage', { language: language });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('destiny/manifest', ['languages']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('firebaseAuth', ['user'])),
  components: {
    TagsEditor: __WEBPACK_IMPORTED_MODULE_4__TagsEditor_vue___default.a,
    FirebaseAuth: __WEBPACK_IMPORTED_MODULE_3__FirebaseAuth_vue___default.a }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LockPanel_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LockPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LockPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransferPanel_vue__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransferPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TransferPanel_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tools',
  props: [],
  data: function data() {
    return {};
  },

  computed: {
    tagsDefinitions: function tagsDefinitions() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.$store.state.tagsDefinitions);
    },
    lockable: function lockable() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.canToggleLock;
      });
    },
    favorited: function favorited() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.canToggleLock && item.favorited;
      });
    },
    notFavorited: function notFavorited() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.canToggleLock && !item.favorited;
      });
    },
    bestDuplicates: function bestDuplicates() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.isImportant;
      }).filter(function (item) {
        return item.canToggleLock && (!item.isDuplicate || item.isBestDuplicate);
      });
    },
    worstDuplicates: function worstDuplicates() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.canToggleLock && item.isDuplicate && !item.isBestDuplicate;
      });
    },
    blueMods: function blueMods() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.bucket.hash === 3313201758;
      }).filter(function (item) {
        return item.tierType.hash === 2127292149;
      });
    },
    blueModsMoreThan3: function blueModsMoreThan3() {
      return this.blueMods.filter(function (item) {
        return item.data.quantity >= 3;
      });
    },
    blueModsLessThan3: function blueModsLessThan3() {
      return this.blueMods.filter(function (item) {
        return item.data.quantity < 3;
      });
    },
    uniqueWeapon: function uniqueWeapon() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return !item.equipped;
      }).filter(function (item) {
        return !item.isDuplicate;
      }).filter(function (item) {
        return item.isWeapon;
      }).filter(function (item) {
        return item.isImportant;
      });
    },
    worstDuplicatesToMove: function worstDuplicatesToMove() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.isDuplicate && !item.isBestDuplicate;
      });
    },
    notEquippedWeapon: function notEquippedWeapon() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return !item.equipped && item.isWeapon;
      });
    },
    notEquippedArmor: function notEquippedArmor() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return !item.equipped && item.isArmor;
      });
    },
    trashItems: function trashItems() {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.isWeapon || item.isArmor;
      }).filter(function (item) {
        return !item.equipped && !item.isImportant;
      });
    },
    vault: function vault() {
      return this.$store.getters['destiny/profile/getCharacter']('VAULT');
    },
    character: function character() {
      if (this.$store.state.destiny.profile.characters) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$store.getters['destiny/profile/getCharacter']('INVENTORY'), { characterId: this.$store.state.destiny.profile.characters[0].characterId, isVault: false });
      }
    },
    characters: function characters() {
      return this.$store.state.destiny.profile.characters || [];
    }
  },
  methods: {
    unLock: function unLock(toUnlock) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(toUnlock.map(function (item) {
        return _this.$store.dispatch('destiny/profile/unLockItem', { item: item });
      }));
    },
    lock: function lock(toLock) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(toLock.map(function (item) {
        return _this2.$store.dispatch('destiny/profile/lockItem', { item: item });
      }));
    },
    forTag: function forTag(tag) {
      return this.$store.state.destiny.profile.items.filter(function (item) {
        return item.canToggleLock && item.hasTag(tag);
      });
    }
  },
  components: {
    TransferPanel: __WEBPACK_IMPORTED_MODULE_5__TransferPanel_vue___default.a,
    Item: __WEBPACK_IMPORTED_MODULE_4__Item_vue___default.a,
    LockPanel: __WEBPACK_IMPORTED_MODULE_3__LockPanel_vue___default.a
  }
});

/***/ }),
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screen.19be7ba.png";

/***/ }),
/* 512 */,
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(564),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-985bedbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-386cb676",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(563),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(568),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c35ad278",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a1ea8b5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(557),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52bde086",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f87a61d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ac0f97f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b8c3c9a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(569),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-497c786c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-116342b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(561),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "manager"
  }, [(_vm.loaded) ? _c('div', [_c('div', [_c('panels')], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('item-list')], 1), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('filters', {
    key: "filter-module",
    attrs: {
      "collapsable": true
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    staticClass: "error"
  }, [_vm._v("Error fetching token, please try again")])])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tokens box"
  }, _vm._l((_vm.tokens), function(ref) {
    var token = ref[0];
    var count = ref[1];

    return (_vm.search) ? _c('div', {
      staticClass: "token",
      on: {
        "click": function($event) {
          _vm.applyToken(token)
        }
      }
    }, [_vm._v("\n    " + _vm._s(token) + "\n  ")]) : _vm._e()
  }))
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searches.length),
      expression: "searches.length"
    }],
    staticClass: "checkboxes searches clickable",
    class: {
      visible: _vm.searchesVisible, collapsable: _vm.collapsable
    }
  }, [_c('h2', {
    staticClass: "shadow",
    on: {
      "click": function($event) {
        _vm.searchesVisible = !_vm.searchesVisible
      }
    }
  }, [_vm._v("Remembered searches")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchesVisible || !_vm.collapsable),
      expression: "searchesVisible || !collapsable"
    }],
    staticClass: "panel shadow"
  }, _vm._l((_vm.searches), function(exportable) {
    return _c('div', {
      staticClass: "remembered-search",
      on: {
        "click": function($event) {
          _vm.applyFilter(exportable)
        }
      }
    }, [_c('div', [_vm._l((_vm.decodeExportable(exportable)), function(ref) {
      var label = ref[0];
      var values = ref[1];

      return _c('span', [_c('strong', [_vm._v(_vm._s(label) + ":")]), _vm._v(" " + _vm._s(values.join(', ')) + ";\n        ")])
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.decodeExportable(exportable).length == 0),
        expression: "decodeExportable(exportable).length==0"
      }]
    }, [_vm._v("\n          Empty\n        ")])], 2), _vm._v(" "), _c('i', {
      staticClass: "material-icons clickable",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteSearch(exportable)
        }
      }
    }, [_vm._v("close")])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item shadow",
    class: {
      'item-transferable': this.transferTarget && _vm.item.canTransferTo(this.transferTarget.characterId), duplicate: _vm.item.isDuplicate
    },
    style: ({
      'background': this.background
    }),
    attrs: {
      "title": _vm.item.definition.displayProperties.description
    },
    on: {
      "dblclick": function($event) {
        $event.stopPropagation();
        _vm.debugItem($event)
      },
      "click": function($event) {
        $event.stopPropagation();
        _vm.transferItem($event)
      }
    }
  }, [(_vm.tagsSelectorVisible) ? _c('tags-selector', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "close": function($event) {
        _vm.tagsSelectorVisible = false
      }
    }
  }, [_c('h2', {
    slot: "header"
  }, [_vm._v("foo bar")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "item-image",
    attrs: {
      "src": _vm.item.icon
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.item.data.itemInstanceId ? _vm.$router.push({
          name: 'item',
          params: {
            instanceId: _vm.item.data.itemInstanceId
          }
        }) : false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.data.quantity > 1),
      expression: "item.data.quantity>1"
    }],
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.item.data.quantity))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n      " + _vm._s(_vm.item.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "type-name"
  }, [_vm._v("\n      " + _vm._s(_vm.item.definition.itemTypeDisplayName) + ", " + _vm._s(_vm.item.bucket.displayProperties.name) + "\n    ")])]), _vm._v(" "), _c('span', {
    staticClass: "class-name"
  }, [_vm._v("\n    " + _vm._s(_vm.item.character.className) + "\n  ")]), _vm._v(" "), (_vm.item.primaryStat) ? _c('div', {
    staticClass: "primary-stat",
    class: [_vm.item.damageTypeName.toLowerCase()]
  }, [_c('div', [(_vm.item.damageType.showIcon) ? _c('img', {
    attrs: {
      "src": _vm.item.damageTypeIcon
    }
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.item.primaryStat) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "real",
    attrs: {
      "title": "Power level without mod"
    }
  }, [_vm._v("\n      (" + _vm._s(_vm.item.realPrimaryStat) + ")\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icons-small"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canEquip),
      expression: "item.canEquip"
    }],
    staticClass: "icon equipped"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.equipped),
      expression: "item.equipped"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unEquip($event)
      }
    }
  }, [_vm._v("bookmark")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.equipped),
      expression: "!item.equipped"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.equip($event)
      }
    }
  }, [_vm._v("bookmark_border")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }],
    staticClass: "icon favorite"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.favorited),
      expression: "item.favorited"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unFavorite($event)
      }
    }
  }, [_vm._v("star")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.favorited),
      expression: "!item.favorited"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.favorite($event)
      }
    }
  }, [_vm._v("star_border")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canToggleLock),
      expression: "item.canToggleLock"
    }],
    staticClass: "icon lock"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.isLocked),
      expression: "item.isLocked"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unLock($event)
      }
    }
  }, [_vm._v("lock")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.isLocked),
      expression: "!item.isLocked"
    }],
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lock($event)
      }
    }
  }, [_vm._v("lock_open")])])]), _vm._v(" "), _c('div', {
    staticClass: "sockets"
  }, _vm._l((_vm.item.displayableSockets), function(socket) {
    return _c('div', {
      staticClass: "socket"
    }, [_c('img', {
      attrs: {
        "src": '//www.bungie.net' + socket.displayProperties.icon,
        "title": socket.displayProperties.name
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "icons"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }],
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTagsSelector($event)
      }
    }
  }, [_vm._v("menu")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allItemsCount),
      expression: "allItemsCount"
    }],
    staticClass: "panel shadow"
  }, [_c('h3', {
    staticClass: "panel-title",
    style: (_vm.headerExtraStyle)
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, _vm._l((_vm.allSources), function(source) {
    return _c('div', {
      staticClass: "button-group"
    }, _vm._l((_vm.targets), function(target) {
      return (target) ? _c('div', {
        staticClass: "button-group"
      }, [_c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.itemsToTransfer(target.characterId, source.characterId).length),
          expression: "itemsToTransfer(target.characterId, source.characterId).length"
        }],
        staticClass: "button",
        on: {
          "click": function($event) {
            _vm.transfer(target, source.characterId)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("play_arrow")]), _c('span', {}, [_vm._v(" " + _vm._s(source.className) + " ➡ " + _vm._s(target.className))]), _vm._v(" "), _c('span', {
        staticClass: "number"
      }, [_vm._v("(" + _vm._s(_vm.itemsToTransfer(target.characterId, source.characterId).length) + ")")])]), _vm._v(" "), _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.itemsToTransfer(target.characterId, source.characterId).length),
          expression: "itemsToTransfer(target.characterId, source.characterId).length"
        }],
        staticClass: "button info",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.preview(target.characterId, source.characterId)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("details")])])]) : _vm._e()
    }))
  })), _vm._v(" "), (_vm.previewItems.length) ? _c('div', {
    staticClass: "preview"
  }, [_c('i', {
    staticClass: "material-icons close",
    on: {
      "click": function($event) {
        _vm.previewItems = []
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _vm._l((_vm.previewItems), function(item) {
    return _c('item', {
      key: _vm.title + item.key,
      attrs: {
        "item": item,
        "character": _vm.currentCharacter
      }
    })
  })], 2) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-as"
  }, [(!_vm.user) ? _c('button', {
    on: {
      "click": _vm.doLogin
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Login with google")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('button', {
    staticClass: "clickable logout",
    on: {
      "click": _vm.doLogout
    }
  }, [_c('img', {
    staticClass: "photo",
    attrs: {
      "src": _vm.user.photoURL
    }
  }), _vm._v(" "), _c('span', [_vm._v("Logout " + _vm._s(_vm.user.displayName))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    class: {
      opened: _vm.opened, selected: _vm.isSelected, 'not-selected': !_vm.isSelected
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSelect($event)
      }
    }
  }, [_c('emblem', {
    staticClass: "click-target",
    attrs: {
      "character": _vm.character
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter"
  }, [_c('search'), _vm._v(" "), _c('favorited-searches', {
    attrs: {
      "collapsable": _vm.collapsable
    }
  }), _vm._v(" "), _vm._l((_vm.filters), function(filter) {
    return _c('div', [_c('checkboxes', {
      attrs: {
        "label": filter.label,
        "items": filter.items,
        "model": filter.model,
        "prefix": filter.name,
        "collapsable": _vm.collapsable,
        "type": filter.filterDefinition.type
      },
      on: {
        "updated": function (value) { return filter.model = value; }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "export"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exportFilterVisible),
      expression: "!exportFilterVisible"
    }],
    on: {
      "click": function($event) {
        _vm.exportFilterVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("content_paste")]), _vm._v(" Export filter\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportFilterVisible),
      expression: "exportFilterVisible"
    }]
  }, [_c('i', {
    staticClass: "material-icons clickable",
    on: {
      "click": function($event) {
        _vm.exportFilterVisible = false
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "exportable"
  }, [_vm._v(_vm._s(_vm.exportable))])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Import filter")])
}]}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('font-size-tracker', [_c('div', {
    staticClass: "emblem",
    class: {
      vault: _vm.character.isVault
    }
  }, [_c('div', {
    staticClass: "emblem-inner",
    style: (_vm.styleObject)
  }), _vm._v(" "), _c('div', {
    staticClass: "class-name"
  }, [_vm._v(_vm._s(_vm.character.className))]), _vm._v(" "), _c('div', {
    staticClass: "gender"
  }, [_vm._v(" " + _vm._s(_vm.character.raceName))]), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_vm._v(_vm._s(_vm.character.level))]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.character.light))])])])
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools"
  }, [_c('h1', [_vm._v("Tools")]), _vm._v(" "), _c('h2', [_vm._v("Locking")]), _vm._v(" "), _c('lock-panel', {
    attrs: {
      "title": "All items",
      "subtitle": "Apply lock to all items",
      "items": _vm.lockable,
      "notMatched": _vm.lockable
    }
  }), _vm._v(" "), _c('lock-panel', {
    attrs: {
      "title": "Favorited",
      "subtitle": "Keep your favorited items safe",
      "items": _vm.favorited,
      "notMatched": _vm.notFavorited
    }
  }), _vm._v(" "), _c('lock-panel', {
    attrs: {
      "title": "Unique and best duplicates",
      "subtitle": "Lock all unique items",
      "items": _vm.bestDuplicates,
      "notMatched": _vm.worstDuplicates
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Transfering")]), _vm._v(" "), _vm._l((_vm.tagsDefinitions), function(ref) {
    var tag = ref[0];
    var definition = ref[1];

    return _c('transfer-panel', {
      key: tag,
      attrs: {
        "color": definition.color,
        "title": 'Tag ' + tag,
        "items": _vm.forTag(tag),
        "targets": _vm.characters
      }
    }, [_vm._v("\n    Move items tagged with tag "), _c('strong', [_vm._v(_vm._s(tag))])])
  }), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Favorites",
      "items": _vm.favorited,
      "targets": _vm.characters
    }
  }, [_vm._v("\n    Move favorited items\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Blue mods to vault",
      "items": _vm.blueModsLessThan3,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Store for future\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Blue mods to characters",
      "items": _vm.blueModsMoreThan3,
      "targets": [_vm.character]
    }
  }, [_vm._v("\n    Exchange them to legendary\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Unique / best duplicates",
      "items": _vm.uniqueWeapon,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Store all unique not equpped weapon to vault, left duplicates are safe to dismantle\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Worst duplicates",
      "items": _vm.worstDuplicatesToMove,
      "targets": _vm.characters
    }
  }, [_vm._v("\n    Move words duplicates to selected character for dismantle\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Not equipped weapon to vault",
      "items": _vm.notEquippedWeapon,
      "sources": _vm.characters,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Make some space for new items\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Not equipped armor to vault",
      "items": _vm.notEquippedArmor,
      "sources": _vm.characters,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Make some space for new items\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Trash",
      "items": _vm.trashItems,
      "targets": _vm.characters.concat( [_vm.vault])
    }
  }, [_vm._v("\n    Not important items\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading-screen'), _vm._v(" "), _c('nav-bar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('current-action'), _vm._v(" "), _c('errors'), _vm._v(" "), (_vm.footerVisible) ? _c('div', {
    staticClass: "contact"
  }, [_vm._v("\n    Crafted with ❤️ by "), _c('a', {
    attrs: {
      "href": "mailto:damian@swistowski.org"
    }
  }, [_vm._v("DŚ")]), _vm._v(", "), _vm._m(0), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": "https://itemmanager.uk/",
      "title": "Item Manager for Destiny 2",
      "description": "Item manager allows you transfer your items between characters with one click",
      "quote": "The fastest item manager for Destiny 2.",
      "hashtags": "destiny,item,manager,vault",
      "twitter-user": "itemmanager"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shares"
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "googleplus"
            }
          }, [_c('i', {
            staticClass: "fa fa-google-plus"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-envelope"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-reddit"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-whatsapp"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons close",
    on: {
      "click": function($event) {
        _vm.footerVisible = false
      }
    }
  }, [_vm._v("close")])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/dswistowski/itemmanager-issues/issues"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sticky', [(_vm.characters) ? _c('section', {
    staticClass: "shadow"
  }, [_vm._l((_vm.characters), function(character) {
    return _c('character-panel', {
      key: character.characterId,
      attrs: {
        "character-id": character.characterId,
        "opened": _vm.opened
      },
      on: {
        "selected": _vm.onSelected
      }
    })
  }), _vm._v(" "), _c('character-panel', {
    key: "panel-vault",
    attrs: {
      "character-id": "VAULT",
      "opened": _vm.opened
    },
    on: {
      "selected": _vm.onSelected
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.opened),
      expression: "!opened"
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openMenu($event)
      }
    }
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "header"
  }, [(!_vm.isLogged) ? _c('router-link', {
    staticClass: "navbar-brand padded",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Item Manager")]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'loader'
      }
    }
  }, [_c('div', {
    staticClass: "user-picture"
  }, [_c('img', {
    attrs: {
      "src": _vm.profilePicturePath
    }
  })])]) : _vm._e(), _vm._v(" "), _c('account-selector'), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged),
      expression: "isLogged"
    }],
    staticClass: "ordering padded"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sort")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordering),
      expression: "ordering"
    }],
    ref: "orderingSelect",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ordering = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allOrderings), function(ordering) {
    return _c('option', {
      domProps: {
        "value": ordering
      }
    }, [_vm._v(_vm._s(ordering))])
  }))]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "filters padded only-small",
    on: {
      "click": function($event) {
        _vm.toggleFilter()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.$route.name === 'filter' ? 'arrow_back' : 'search'))])]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.handleRefresh()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Reload")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("refresh")])]) : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogged),
      expression: "!isLogged"
    }],
    staticClass: "login padded",
    on: {
      "click": function($event) {
        _vm.handleLogin()
      }
    }
  }, [_c('span', [_vm._v("Authorize with Bungie.net")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock_open")])]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'tools'
        })
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Tools")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("build")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'settings'
        })
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.user),
      expression: "!user"
    }],
    staticClass: "padded only-big",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'settings'
        })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_off")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user),
      expression: "user"
    }],
    staticClass: "padded only-big"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged),
      expression: "isLogged"
    }],
    staticClass: "login padded",
    on: {
      "click": function($event) {
        _vm.handleLogout()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Logout")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("exit_to_app")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-editor"
  }, [_c('h2', [_vm._v("Tags")]), _vm._v(" "), _vm._l((_vm.tagsDefinitions), function(ref) {
    var tag = ref[0];
    var tagDefinition = ref[1];

    return _c('div', [_c('div', {
      staticClass: "tag-definition",
      style: ({
        'background-color': tagDefinition.color
      })
    }, [_vm._v(_vm._s(tag) + "\n      "), _c('i', {
      staticClass: "material-icons delete",
      on: {
        "click": function($event) {
          _vm.deleteTagDefinition(tag)
        }
      }
    }, [_vm._v("close")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": tagDefinition.color
      },
      on: {
        "change": function($event) {
          _vm.setTagDefinition(tag, $event.target.value)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-tag-definition"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    attrs: {
      "placeholder": "add tag",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTagDefinition(_vm.newTag)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    on: {
      "click": function($event) {
        _vm.addTagDefinition(_vm.newTag)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "item-detail",
    style: ({
      backgroundImage: 'url(//www.bungie.net' + _vm.item.definition.screenshot + ')'
    })
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons clickable"
  }, [_vm._v("\n      close\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "column",
    style: ({
      backgroundImage: _vm.item.definition.secondaryIcon ? 'url(//www.bungie.net' + _vm.item.definition.secondaryIcon + ')' : ''
    })
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "item-icon",
    attrs: {
      "src": '//www.bungie.net' + _vm.item.definition.displayProperties.icon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "definition"
  }, [_c('h1', [_vm._v(_vm._s(_vm.item.name.toUpperCase()))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.item.definition.itemTypeDisplayName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canEquip),
      expression: "item.canEquip"
    }],
    staticClass: "icon equipped"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.equipped),
      expression: "item.equipped"
    }],
    staticClass: "material-icons",
    attrs: {
      "title": "unequip"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unEquip($event)
      }
    }
  }, [_vm._v("bookmark")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.equipped),
      expression: "!item.equipped"
    }],
    staticClass: "material-icons",
    attrs: {
      "title": "equip"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.equip($event)
      }
    }
  }, [_vm._v("bookmark_border")])]), _vm._v(" "), _c('div', {
    staticClass: "icon favorite"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.favorited),
      expression: "item.favorited"
    }],
    staticClass: "material-icons",
    attrs: {
      "title": "unfavorite"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unFavorite($event)
      }
    }
  }, [_vm._v("star")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.favorited),
      expression: "!item.favorited"
    }],
    staticClass: "material-icons",
    attrs: {
      "title": "favorite"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.favorite($event)
      }
    }
  }, [_vm._v("star_border")])])]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.item.definition.displayProperties.description))]), _vm._v(" "), _c('div', {
    staticClass: "tokens"
  }, _vm._l((_vm.item.tokens), function(token) {
    return _c('span', {
      staticClass: "token shadow",
      on: {
        "click": function($event) {
          _vm.searchToken(token)
        }
      }
    }, [_vm._v(_vm._s(token))])
  })), _vm._v(" "), _c('div', {
    staticClass: "sockets"
  }, _vm._l((_vm.item.sockets), function(socket) {
    return _c('div', {
      staticClass: "socket"
    }, [_c('img', {
      attrs: {
        "src": '//www.bungie.net' + socket.displayProperties.icon,
        "title": socket.displayProperties.name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "detail"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('h1', [_vm._v(_vm._s(socket.displayProperties.name))]), _vm._v("\n            " + _vm._s(socket.itemTypeDisplayName) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "body"
    }, [_vm._v("\n            " + _vm._s(socket.displayProperties.description) + "\n          ")])])])
  })), _vm._v(" "), _c('table', {
    staticClass: "stats"
  }, _vm._l((_vm.item.stats), function(stat) {
    return _c('tr', {
      key: stat.hash
    }, [_c('td', {
      staticClass: "label"
    }, [_vm._v(_vm._s(stat.definition.displayProperties.name))]), _vm._v(" "), _c('td', {
      staticClass: "value"
    }, [_vm._v(_vm._s(stat.value))])])
  }))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.key
    }, [_c('item', {
      attrs: {
        "item": item
      }
    })], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.errors.length) ? _c('div', {
    staticClass: "errors",
    class: {
      visible: _vm.errors.length
    },
    on: {
      "click": _vm.popError
    }
  }, [_c('div', {
    staticClass: "message shadow"
  }, [_vm._v("\n    " + _vm._s(_vm.errors[0]) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.stopPropagation();
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.stopPropagation();
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h2', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.item.name) + "\n          "), _c('a', {
    staticClass: "model-close-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._l((_vm.targets), function(target) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.item.canTransferTo(target.characterId)),
        expression: "item.canTransferTo(target.characterId)"
      }],
      staticClass: "button transfer",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.item.transfer(target)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": target.emblemPath
      }
    }), _vm._v(" "), _c('span', [_vm._v("Transfer ➡ " + _vm._s(target.className))])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canEquip),
      expression: "item.canEquip"
    }],
    staticClass: "icon equipped"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.equipped),
      expression: "item.equipped"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unEquip($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("bookmark")]), _vm._v("\n              Equipped\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.equipped),
      expression: "!item.equipped"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.equip($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("bookmark_border")]), _vm._v(" Unequipped\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }],
    staticClass: "icon favorite"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.favorited),
      expression: "item.favorited"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unFavorite($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("star")]), _vm._v("\n              Favorited\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.favorited),
      expression: "!item.favorited"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.favorite($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("star_border")]), _vm._v(" Unfavorited\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.canToggleLock),
      expression: "item.canToggleLock"
    }],
    staticClass: "icon lock"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.isLocked),
      expression: "item.isLocked"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unLock($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _vm._v(" Locked\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.isLocked),
      expression: "!item.isLocked"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lock($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock_open")]), _vm._v("\n              Unlocked\n            ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.key),
      expression: "item.key"
    }]
  }, [_vm._l((_vm.tagsDefinitions), function(ref) {
    var tag = ref[0];
    var tagDefinition = ref[1];

    return _c('div', [_c('div', {
      staticClass: "tag",
      class: {
        'enabled': _vm.item.hasTag(tag)
      },
      style: ({
        'background-color': tagDefinition.color
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleTag(tag)
        }
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.item.hasTag(tag)),
        expression: "item.hasTag(tag)"
      }],
      staticClass: "fa fa-check"
    }), _vm._v("\n                " + _vm._s(tag) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n              You can edit tags in  "), _c('a', {
    staticClass: "padded",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'settings'
        })
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("settings")])])])], 2)], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasFilter),
      expression: "!hasFilter"
    }],
    staticClass: "material-icons"
  }, [_vm._v("search")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasFilter),
      expression: "hasFilter"
    }],
    staticClass: "material-icons clickable",
    attrs: {
      "title": "clear fiters"
    },
    on: {
      "click": function($event) {
        _vm.clearSearch()
      }
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAddSearch),
      expression: "canAddSearch"
    }],
    staticClass: "material-icons add-search",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addSearch(_vm.exportable)
      }
    }
  }, [_vm._v("star_border")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.canAddSearch),
      expression: "!canAddSearch"
    }],
    staticClass: "material-icons remove-search",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteSearch(_vm.exportable)
      }
    }
  }, [_vm._v("star")])])
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "loading-screen"
  }, [_c('div', {
    staticClass: "loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.loading))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('h1', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.languages.length),
      expression: "languages.length"
    }],
    staticClass: "language-settings"
  }, [_c('h2', [_vm._v("Language")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "manifest-file-language"
    }
  }, [_vm._v("Manifest file language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    attrs: {
      "id": "manifest-file-language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageOptions), function(language) {
    return _c('option', {
      domProps: {
        "value": language.code
      }
    }, [_vm._v(_vm._s(language.name))])
  })), _vm._v(" "), _c('p', [_vm._v("This option requires page reload after change to apply")])]), _vm._v(" "), _c('div', {
    staticClass: "firebase-sync"
  }, [_c('h2', [_vm._v("Sync")]), _vm._v(" "), _c('firebase-auth')], 1), _vm._v(" "), _c('tags-editor')], 1)
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel shadow"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_vm._v("\n    " + _vm._s(_vm.subtitle) + "\n\n    "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "button-group"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsToLock.length),
      expression: "itemsToLock.length"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.doLock()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock")]), _c('span', {
    staticClass: "label"
  }, [_vm._v(" Lock")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(" + _vm._s(_vm.itemsToLock.length) + ")")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsToLock.length),
      expression: "itemsToLock.length"
    }],
    staticClass: "button info",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.previewItems = _vm.itemsToLock
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("details")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsToUnlock.length),
      expression: "itemsToUnlock.length"
    }],
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.doUnlock(_vm.itemsToUnlock)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("lock_open")]), _c('span', {
    staticClass: "label"
  }, [_vm._v(" Unlock")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(" + _vm._s(_vm.itemsToUnlock.length) + ")")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsToUnlock.length),
      expression: "itemsToUnlock.length"
    }],
    staticClass: "button info",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.previewItems = _vm.itemsToUnlock
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("details")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notMatchedItems.length),
      expression: "notMatchedItems.length"
    }],
    staticClass: "button",
    attrs: {
      "title": "Will unlock all not matching items"
    },
    on: {
      "click": function($event) {
        _vm.doUnlock(_vm.notMatchedItems)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("error")]), _c('span', {
    staticClass: "label"
  }, [_vm._v(" Not matching")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(" + _vm._s(_vm.notMatchedItems.length) + ")")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notMatchedItems.length),
      expression: "notMatchedItems.length"
    }],
    staticClass: "button info",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.previewItems = _vm.notMatchedItems
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("details")])])])]), _vm._v(" "), (_vm.previewItems.length) ? _c('div', {
    staticClass: "preview"
  }, [_c('i', {
    staticClass: "material-icons close",
    on: {
      "click": function($event) {
        _vm.previewItems = []
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _vm._l((_vm.previewItems), function(item) {
    return _c('item', {
      key: _vm.subtitle + item.key,
      attrs: {
        "item": item
      }
    })
  })], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.items.length) ? _c('div', {
    ref: "movable",
    staticClass: "checkboxes",
    class: {
      visible: _vm.visible, collapsable: _vm.collapsable, pinned: _vm.pinned, dragged: _vm.dragged
    },
    style: ({
      top: _vm.top,
      left: _vm.left
    }),
    on: {
      "mousedown": function($event) {
        _vm.onMouseDown($event)
      },
      "mousemove": function($event) {
        _vm.onMouseMove($event)
      }
    }
  }, [_c('div', {
    staticClass: "panel shadow"
  }, [_c('h2', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleVisible()
      }
    }
  }, [_vm._v(_vm._s(_vm.label) + "\n        "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePinned($event)
      }
    }
  }, [_vm._v("place")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible || !_vm.collapsable),
      expression: "visible || !collapsable"
    }],
    staticClass: "panel-content"
  }, _vm._l((_vm.items), function(category) {
    return _c('div', {
      key: _vm.key(category),
      class: 'md-' + _vm.type
    }, [_c('input', {
      attrs: {
        "type": _vm.type,
        "id": _vm.key(category)
      },
      domProps: {
        "value": category.hash,
        "checked": _vm.model.indexOf(category.hash) !== -1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.updateValue($event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.key(category)
      }
    }, [_vm._v(_vm._s(category.name))])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItems && !_vm.visible),
      expression: "selectedItems && !visible"
    }],
    staticClass: "panel-content result",
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.selectedItems) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldShow) ? _c('div', {
    staticClass: "account-selector"
  }, [_c('div', {
    staticClass: "display-name"
  }, [_vm._v("\n    " + _vm._s(_vm.displayName) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "help"
  }, [_c('h2', [_vm._v("FAQ")]), _vm._v(" "), _c('h3', [_vm._v("Is it safe?")]), _vm._v(" "), _c('p', [_vm._v("Yes, the app is using official Bungie API. After authorization - Bungie provides one-hour valid token which is stored only in your local session and is not send anywhere else. The token allows only to transfer items, change lock state. Bungie does not allow to do any not reversible operations - like dismantle or infuse items")]), _vm._v(" "), _c('h3', [_vm._v("How does it work?")]), _vm._v(" "), _c('p', [_vm._v("After authorization, select your target on the top nav bar (any character on vault), then click the item. Item will be transferred to the selected character.\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Why this app, not other already existing?")]), _vm._v(" "), _c('p', [_vm._v("A long time ago, I've created Vault helper what was the first item manager app for Destiny. My UI approach was always different than others. It can be not so intuitive but is more efficient in the long run.")]), _vm._v(" "), _c('h3', [_vm._v("How search works")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("You can search by name - just type part of your item name: "), _c('code', [_vm._v("Mida mu")])]), _vm._v(" "), _c('li', [_vm._v("You can search by tier - just type the tier: "), _c('code', [_vm._v("legendary")])]), _vm._v(" "), _c('li', [_vm._v("You can search by power level - try: "), _c('code', [_vm._v("265+")]), _vm._v(", "), _c('code', [_vm._v("280-290")])]), _vm._v(" "), _c('li', [_vm._v("You can search by type - try: "), _c('code', [_vm._v("legs")]), _vm._v(", "), _c('code', [_vm._v("ship")]), _vm._v(", "), _c('code', [_vm._v("energy")])]), _vm._v(" "), _c('li', [_vm._v("You can search by subtype - try: "), _c('code', [_vm._v("submachine")])]), _vm._v(" "), _c('li', [_vm._v("You can search by damage type - try: "), _c('code', [_vm._v("solar")]), _vm._v(", "), _c('code', [_vm._v("void")])]), _vm._v(" "), _c('li', [_vm._v("You can search by character - try: "), _c('code', [_vm._v("vault")]), _vm._v(", "), _c('code', [_vm._v("warlock")])]), _vm._v(" "), _c('li', [_vm._v("You can search for duplicates - try: "), _c('code', [_vm._v("duplicate")])]), _vm._v(" "), _c('li', [_vm._v("You can search for rare modifications which you cannot exchange to legendary ones yet "), _c('code', [_vm._v("rare modifications 1-2 characters")])]), _vm._v(" "), _c('li', [_vm._v("You can find rare modification to change to legendary which are stored in valut: "), _c('code', [_vm._v("rare modifications 3+ vault")])])]), _vm._v(" "), _c('p', [_vm._v("You can join searches - "), _c('code', [_vm._v("legendary submachine solar 280+")]), _vm._v(" will show only legendary submachine guns with solar modifier and power level bigger than 280.")]), _vm._v(" "), _c('p', [_vm._v("Additionally you can save search by pressing star icon. Your searchs are stored in browser local storage, so you can use them later on the same browser")]), _vm._v(" "), _c('h3', [_vm._v("Can I change sort order?")]), _vm._v(" "), _c('p', [_vm._v("Yes, please mind the search option on your navbar - near "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("sort")]), _vm._v(" icon. You can use it to change current sorting.")]), _vm._v(" "), _c('h3', [_vm._v("I have questions/suggestion what should I do?")]), _vm._v(" "), _c('p', [_vm._v("Just send me an email - "), _c('a', {
    attrs: {
      "href": "mailto:damian@swistowski.org"
    }
  }, [_vm._v("damian@swistowski.org")]), _vm._v(" or go to "), _c('a', {
    attrs: {
      "href": "https://github.com/dswistowski/itemmanager-issues/issues"
    }
  }, [_vm._v("https://github.com/dswistowski/itemmanager-issues/issues")]), _vm._v(" and fill new issue")])])
}]}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    class: {
      fixed: _vm.fixed, source: true
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "sizer"
  })])
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    key: "filter-page",
    attrs: {
      "collapsable": false
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-action",
    class: {
      visible: _vm.currentActionMessage
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentActionMessage),
      expression: "currentActionMessage"
    }],
    staticClass: "message shadow",
    domProps: {
      "innerHTML": _vm._s(_vm.currentActionMessage)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "center"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("The fastest item manager for Destiny 2")]), _vm._v(" "), _c('a', {
    staticClass: "button shadow",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Please Authorize with Bungie.net to proceed.")])]), _vm._v(" "), _c('div', {
    staticClass: "center spread shadow"
  }, [_c('social-sharing', {
    attrs: {
      "url": "https://itemmanager.uk/",
      "title": "Item Manager for Destiny 2",
      "description": "Item manager allows you transfer your items between characters with one click",
      "quote": "The fastest item manager for Destiny 2.",
      "hashtags": "destiny,item,manager,vault",
      "twitter-user": "itemmanager"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook"
          }), _vm._v(" Facebook\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "googleplus"
            }
          }, [_c('i', {
            staticClass: "fa fa-google-plus"
          }), _vm._v(" Google +\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-envelope"
          }), _vm._v(" Email\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-reddit"
          }), _vm._v(" Reddit\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter"
          }), _vm._v(" Twitter\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('i', {
            staticClass: "fa fa-vk"
          }), _vm._v(" VKontakte\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "weibo"
            }
          }, [_c('i', {
            staticClass: "fa fa-weibo"
          }), _vm._v(" Weibo\n        ")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-whatsapp"
          }), _vm._v(" Whatsapp\n        ")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "screen-shot",
    attrs: {
      "src": __webpack_require__(511)
    }
  }), _vm._v(" "), _c('help')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Welcome to the "), _c('strong', [_vm._v("Item Manager")]), _vm._v(".")])
}]}

/***/ }),
/* 570 */,
/* 571 */,
/* 572 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[335]);


// WEBPACK FOOTER //
// static/js/app.06e6b84e55b04ffc7f31.js